interface Window {
    mapTranslations: { [id: string]: string };
}

module MapDrawing {
    import MapDrawerData = SolarProTool.MapDrawerData;
    import GmMeshMaterial = spt.ThreeJs.utils.GmMeshMaterial;

    export class MapDrawer implements IEventManager {
        // region Static Properties
        static staticInitialized: boolean;
        static EmptyCanvas: string = "Canvas";
        // endregion

        // region Properties
        //mouseEventCreation: boolean;
        viewModel: ViewModel;
        dialog: Element;
        view: Element;
        mapsViewWrapper: HTMLElement;
        mapsView: HTMLElement;
        map: google.maps.Map;
        ghostShapes: IGoogleMapsPolygon[];
        elevationService: google.maps.ElevationService;
        eraseMode = false;
        private drawingMode = false;
        private _eventsBound = false;
        zoomOnlyMode = false;
        shiftDown = false;
        ctrlDown = false;
        altDown = false;
        spaceDown = false;
        private _hasFocus = false;
        private _mapEventListener: google.maps.MapsEventListener[] = [];
        mapBounds: google.maps.LatLngBounds | null = null;
        mouseDown = false;
        options: IMapDrawerOptions;
        _projection: google.maps.Projection = null;
        center: LatLng = new LatLng();
        mapTypeIds: string[] = [MapDrawer.EmptyCanvas];
        tileManager: TileManager[];
        ocrManager: OCRTileManager;
        tempPolyData: PolyData[] = [];
        canvasOverlay: CanvasOverlay;
        osmBuildings: OsmBuildings;
        gis3DBuildings: Gis3DBuildings;
        show3dBuildings: boolean = false;
        show3dBuildingsBtn: HTMLButtonElement = null;
        goToProjectBtn: HTMLButtonElement = null;
        showNinetyDegreeCorrectionBtn: HTMLButtonElement = null;
        correctionRightAngleControl: JQuery | null = null;
        ninetyDegreeCorrection: boolean = true;
        get isFacade(): boolean {
            return $("input[type='radio'][name='Roof.RoofForm_Id']:checked").val() === "161ff892-a877-448b-acc1-91038b924465";
        }
        
        // region Properties Shapes
        ghostShapeStyle: IShapeStyle = {
            strokeWeight: 2,
            fillColor: "#616161",
            fillOpacity: 0.5,
            strokeColor: "#262626",
            strokeOpacity: 0.8,
            clickable: false,
            editable: false,
            draggable: false,
            visible: true
        };

        shapeSelectedHoveredStyle: IShapeStyle = {
            strokeWeight: 1.5,
            fillColor: '#bf4900',
            fillOpacity: 0.6,
            strokeColor: '#bf4900',
            strokeOpacity: 0.9
        };

        shapeSelectedStyle: IShapeStyle = {
            strokeWeight: 4,
            fillColor: '#bf4900',
            fillOpacity: 0.5,
            strokeColor: '#bf4900',
            strokeOpacity: 0.8
        };

        shapeHoveredStyle: IShapeStyle = {
            strokeWeight: 1,
            fillColor: '#13235B',
            fillOpacity: 0.5,
            strokeColor: '#A500AC',
            strokeOpacity: 0.8
        };

        shapeStyle: IShapeStyle = {
            strokeWeight: 1,
            fillColor: '#13235B',
            fillOpacity: 0.4,
            strokeColor: '#A500AC',
            strokeOpacity: 0.7
        };

        // endregion

        // endregion
        constructor(view: Element, options?: IMapDrawerOptions) {
            if (!MapDrawer.staticInitialized) {
                MapDrawer.staticInitialized = true;

                ImageMapOverlay.initializePrototype();
                CanvasOverlay.initializePrototype();
            }

            this.view = view;
            
            if (!this.isFacade){
                this.mapTypeIds.push("Google");
                // TODO BING Maps delete: Do not remove comment in case we want to add bingmaps again
                // this.mapTypeIds.push("BING");
            }
            
            /*
            if (window["GMapsUtils"] && window["GMapsUtils"].OctantNodeRenderer && this.mapTypeIds && this.mapTypeIds.indexOf("Google HD") === -1 && !this.isFacade)
                this.mapTypeIds.push("Google HD");
             */
            
            this.init(options);
        }

        init(options?: IMapDrawerOptions, skipBindings?: boolean) {
            this.correctionRightAngleControl = null;
            
            this.options = {
                center: { lat: 0, lng: 0 },
                width: 200,
                height: 200,
                pathToIcons: "~/",
                pathToButtons: "~/",
                dialogId: null,
                tileUrl: "../../handler/StaticImagesHandler.ashx",
                isReadOnly: false
            };

            if (options) {
                for (var key in options) {
                    if (options.hasOwnProperty(key))
                        this.options[key] = options[key];
                }
            }

            options = this.options;

            if (options.pathToIcons.slice(-1) !== "/")
                options.pathToIcons += "/";

            if (options.dialogId) {
                this.dialog = document.getElementById(options.dialogId);
                DManager.init(this.dialog, 'auto', 'auto', SetWidthDialogTitleBarWidth, this.onDialogClose.bind(this), { closeOnEscape: false });
            }

            var view = this.view;
            var viewModel = this.viewModel;

            if (!viewModel)
                this.viewModel = viewModel = new ViewModel(this, view, options.editorMode);
            else
                viewModel.init(this, view, options.editorMode);

            if ($(".mapDrawerViewWrapper", this.view).length === 0 && !skipBindings) {
                //div not yet available. try apply knockout first and init again later.

                viewModel.mapDrawerRenderCallback = this.init.bind(this, options, true);
                ko.applyBindings(viewModel, view);
                return;
            }

            viewModel.mapDrawerRenderCallback = null;
            viewModel.isFacade = this.isFacade;

            var mapsViewWrapper = this.mapsViewWrapper = $(".mapDrawerViewWrapper", this.view).get(0);
            var mapsView = this.mapsView = $(".mapDrawerView", mapsViewWrapper).get(0);
            var map = this.map;
            var zoom = 21;
            let tilesize = LatLng.TILE_SIZE;
            var applyBindings = !skipBindings;
            var url = options.tileUrl;
            
            var mapTypeId = this.isFacade ?  MapDrawer.EmptyCanvas : (options.mapTypeId || MapDrawer.EmptyCanvas);

            const devMapBackground = this.getDevMapBackgroundConfig();

            this.center.set(options.center.lat, options.center.lng);

            mapsViewWrapper.style.width = mapsView.style.width = options.width + "px";
            mapsViewWrapper.style.height = mapsView.style.height = options.height + "px";
            viewModel.viewWidth = options.width;
            viewModel.viewHeight = options.height;
            
            var processtab = parseInt($('#ProcessStep').val() as string);

            if (map && processtab > 2) {
                google.maps.event.trigger(map, "resize");
                
                map.setCenter(options.center);

                map.setZoom(zoom);

                map.setMapTypeId(mapTypeId);

                this.viewModel.registerMapListeners(map);
                applyBindings = false;
            }
            else {
                map = new google.maps.Map(mapsView, {
                    zoom: zoom,
                    center: new google.maps.LatLng(options.center.lat, options.center.lng),
                    mapTypeId: google.maps.MapTypeId.SATELLITE,
                    heading: 0,
                    tilt: 0,
                    mapTypeControl: false, // hide (for custom styling) original google control group
                    mapTypeControlOptions: {
                        mapTypeIds: this.mapTypeIds
                    },
                    streetViewControl: false,
                    disableDoubleClickZoom: true,
                    overviewMapControl: false,
                    panControl: false,
                    rotateControl: false,
                    scaleControl: false,
                    scrollwheel: true,
                    zoomControl: false,
                    disableDefaultUI: true,
                    gestureHandling: 'greedy'
                });

                var mapMaxZoom = 25;

                var tileManager = this.tileManager,
                    ocrManager = this.ocrManager;

                if (!tileManager) {
                    tileManager = this.tileManager = [
                        null
                        , new TileManager(this, url + "?ID=GoogleHybrid", this.mapTypeIds[1])
                        // TODO BING Maps delete: Do not remove comment in case we want to add bingmaps again
                        // , new TileManager(this, url + "?ID=Bing", this.mapTypeIds[2])
                    ];
                }
                // TODO BING Maps delete: Do not remove comment in case we want to add bingmaps again
                // if (!ocrManager && this.mapTypeIds[3])
                if (!ocrManager && this.mapTypeIds[2])
                    ocrManager = this.ocrManager = new OCRTileManager(this, url + "?ID=GoogleSatellite", this.mapTypeIds[3]);
                
                map.mapTypes.set(this.mapTypeIds[0],
                    {
                        getTile: (coord: google.maps.Point, zoom: number, ownerDocument: Document) => {
                            var div = ownerDocument.createElement('div');
                            
                            div.className = "md-tile";
                            return div;
                        },
                        releaseTile: (tile: Element) => {
                            if (tile && tile.parentElement)
                                tile.parentElement.removeChild(tile);
                        },
                        tileSize: new google.maps.Size(tilesize, tilesize),
                        name: this.mapTypeIds[0],
                        maxZoom: mapMaxZoom,
                        minZoom: 0
                    });
                if (!this.isFacade){
                    map.mapTypes.set(this.mapTypeIds[1],
                        {
                            getTile: tileManager[1].getTileDiv.bind(tileManager[1]),
                            releaseTile: tileManager[1].releaseTile.bind(tileManager[1]),
                            tileSize: new google.maps.Size(tilesize, tilesize),
                            name: this.mapTypeIds[1],
                            maxZoom: mapMaxZoom,
                            minZoom: 1
                        });
                    // TODO BING Maps delete: Do not remove comment in case we want to add bingmaps again
                    // map.mapTypes.set(this.mapTypeIds[2], {
                    //     getTile: tileManager[2].getTileDiv.bind(tileManager[2]),
                    //     releaseTile: tileManager[2].releaseTile.bind(tileManager[2]),
                    //     tileSize: new google.maps.Size(tilesize, tilesize),
                    //     name: this.mapTypeIds[2],
                    //     maxZoom: mapMaxZoom,
                    //     minZoom: 1
                    // });

                    // TODO BING Maps delete: Do not remove comment in case we want to add bingmaps again
                    // use mapTypeId[3] instead of 2 for bing use
                    if (ocrManager) {
                        map.mapTypes.set(this.mapTypeIds[2], {
                            getTile: ocrManager.getTileDiv.bind(ocrManager),
                            releaseTile: ocrManager.releaseTile.bind(ocrManager),
                            tileSize: new google.maps.Size(tilesize, tilesize),
                            name: this.mapTypeIds[2],
                            maxZoom: mapMaxZoom,
                            minZoom: 1
                        });
                        viewModel.enableDepthCalculation = true;
                    } else{
                        viewModel.enableDepthCalculation = false;
                    }
                }
                
                map.setMapTypeId(mapTypeId);
				
				this.drawNorthCompass();
				
                this.map = map;
                this.viewModel.registerMapListeners(map);

                if (devMapBackground.enabled && !this.isFacade) {
                    if (devMapBackground.initialMapTypeId) {
                        map.setMapTypeId(devMapBackground.initialMapTypeId);
                    }
                    map.controls[google.maps.ControlPosition.TOP_LEFT].push(
                        this.getMapDrawerControlBtnGroup("" + map.getMapTypeId(), map));
                }

                setTimeout(() => {
                    google.maps.event.trigger(map, "resize");
                }, 0);
            }

            if (!this.elevationService)
                this.elevationService = new google.maps.ElevationService();

            if (!this._eventsBound) {
                this._eventsBound = true;
                if (!options.isReadOnly)
                    this.bindEvents();
            }

            if (!this.canvasOverlay)
                this.canvasOverlay = new CanvasOverlay(this);
            else {
                this.canvasOverlay.clear();
                this.canvasOverlay.init(this);
            }
            this.canvasOverlay.clear();

            if (!this.osmBuildings) {
                this.osmBuildings = new OsmBuildings();
            }
            
            if (applyBindings)
                ko.applyBindings(this.viewModel, this.dialog || this.view);

            
            this.gis3DBuildings = new Gis3DBuildings();
            
            // If there are no 3D buildings, the button "Show 3D Buildings" should be disabled.
            this.checkForVisible3DBuildings();

            this.registerOutsideCoverageClickListener();

            // show the 3d-info-dialog when 3d is available
           this.show3DInfoDialog();
            
            this.load();
        }
       
        show3DInfoDialog(){
            // show the 3d-info-dialog when 3d is available
            this.gis3DBuildings.downloadBorderJson().then((borderJson) => {
                if (!borderJson) return;
                const bounds = this.map.getBounds();
                if (!bounds) {
                    google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => this.show3DInfoDialog());
                    return;
                }
                const anyIntersection = hasAnyIntersections(bounds, borderJson);
                lsGoogleMaps.report3dBuildingsInView(anyIntersection);
            });
        }
		
        query3DAvailability(): Promise<boolean> {
            return this.gis3DBuildings.downloadBorderJson().then((borderJson) => {
                if (!borderJson) return false;
                const bounds = this.map.getBounds();
                if (bounds) {
                    return hasAnyIntersections(bounds, borderJson);
                }
                return new Promise<boolean>((resolve) => {
                    google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
                        const readyBounds = this.map.getBounds();
                        resolve(readyBounds ? hasAnyIntersections(readyBounds, borderJson) : false);
                    });
                });
            });
        }
        async checkForVisible3DBuildings() {
            const self = this;

            let debounceTimeout: number | null = null;

            self.map.addListener('idle', () => {
                if (debounceTimeout) clearTimeout(debounceTimeout);

                debounceTimeout = window.setTimeout(() => {
                    this.gis3DBuildings.downloadBorderJson().then((borderJson) => {
                        updateButtonState();
                        function updateButtonState() {
                            const mapBounds = self.map.getBounds();
                            if (!mapBounds || !borderJson) return;
                            const anyIntersection = hasAnyIntersections(mapBounds, borderJson);
                            lsGoogleMaps.report3dBuildingsInView(anyIntersection);
                            self.viewModel.buildings3dDataAvailable = anyIntersection;
                            
                            if (self.show3dBuildingsBtn) {
                                self.show3dBuildingsBtn.disabled = !anyIntersection;
                                self.show3dBuildingsBtn.hidden = !anyIntersection;
                            }

                            if (self.show3dBuildings && !anyIntersection) {
                                // keep 3D mode active to avoid silently losing the selected roof
                                // outside clicks open a confirmation dialog
                                const gis3dTool = self.viewModel.toolIcons?.["Gis3DBuildingsTool"] as Gis3DBuildingsTool | undefined;
                                if (!gis3dTool?.hasSelectedRoof) {
                                    self.show3dBuildings = false;
                                    self.viewModel.toggleGis3DBuildingsTool(self.show3dBuildings);
                                    self.updateShow3DBuildingsButtonState();
                                }
                            }
                        }
                    });
                }, 1000);
            });
        }
        
        private _outsideCoverageClickListener: google.maps.MapsEventListener | null = null;

        private registerOutsideCoverageClickListener() {
            if (this._outsideCoverageClickListener) {
                google.maps.event.removeListener(this._outsideCoverageClickListener);
                this._outsideCoverageClickListener = null;
            }

            this._outsideCoverageClickListener = this.map.addListener('click', (ev: google.maps.MouseEvent) => {
                if (!this.show3dBuildings || this.viewModel.buildings3dDataAvailable || !ev.latLng) {
                    return;
                }

                const gis3dTool = this.viewModel.toolIcons?.["Gis3DBuildingsTool"] as Gis3DBuildingsTool | undefined;
                if (!gis3dTool?.hasSelectedRoof) {
                    return;
                }

                lsGoogleMaps.reportMapClickedOutside3DCoverage(ev.latLng.lat(), ev.latLng.lng());
            });
        }

        onOverlaycomplete(newShape: google.maps.Polygon, ignoreDrawingMode = false) {
            if (!ignoreDrawingMode && !this.drawingMode) {
                newShape.setMap(null);
                return;
            }

            if (newShape instanceof google.maps.Polygon) {
                var paths = newShape.getPaths();
                var path = paths && paths.getLength() ? paths.getAt(0) : null;
                var area = path ? google.maps.geometry.spherical.computeSignedArea(path) : 0; //in m²
                var layer = this.viewModel.currentLayer;
                if (!path || path.getLength() < 3 || Math.abs(area) <= 0.01 || (layer && layer.locked)) {
                    newShape.setMap(null);
                    if (layer && layer.locked)
                        this.selectTool(null);
                } else {
                    this.addPolygon(newShape as any);

                    // only applies to user-drawn building shapes; imports and interference tools are excluded
                    if (!ignoreDrawingMode && layer?.typeName === "Building") {
                        const shapeCenter = this.getBoundsFromPolygon(newShape as any).getCenter();
                        lsGoogleMaps.reportRoofPlacedAt(shapeCenter.lat(), shapeCenter.lng(), () => {
                            const data = (newShape as any).userData as ShapeData;
                            if (data && !(data as any)._isDisposed) {
                                this.deleteSelectables([data]);
                            }
                        });
                        (window as any).lsGoogleMaps?.onManualBuildingDrawn?.((newShape as any).userData);
                    }
                }
            }
        }


        private _onEscapeKey() {
            const currentToolName = this.viewModel.currentTool?.name;
            const isDrawingTool = currentToolName === 'DrawTool' || currentToolName === 'SimpleRidgeTool' || currentToolName === 'RidgeTool' || currentToolName === 'CutTool';
            if ((this.hasFocus || isDrawingTool) && this.viewModel.isDrawingMode) {
                this.selectTool(null);
            }
        }

        unBindEvents() {
            var view = this.view;

            this._mapEventListener.splice(0, this._mapEventListener.length).forEach(listener => {
                if (listener.remove)
                    listener.remove();
            });

            document.removeEventListener('keydown', this.keyDownHandler);
            document.removeEventListener('keyup', this.keyUpHandler);

            if (!$.isTouchCapable()) {
                document.removeEventListener('mousedown', this.mouseDownHandler, true);
                document.removeEventListener('mouseup', this.mouseUpHandler, true);
                view.removeEventListener('mousedown', this.viewMouseDownHandler, true);
                view.removeEventListener('mousemove', this.mouseMoveHandler, true);
            }
            else {
                view.removeEventListener('touchstart', this.viewMouseDownHandler, true);
                view.removeEventListener('touchmove', this.mouseMoveHandler, true);
                view.removeEventListener('touchend', this.mouseUpHandler, true);
            }

            this.keyDownHandler = null;
            this.keyUpHandler = null;;
            this.mouseDownHandler = null;;
            this.viewMouseDownHandler = null;;
        }

        isViewMouseDown = false;
        isViewMouseMoving = false;
        isViewStartMoving = false;
        lastMouseDownEvent: google.maps.MouseEvent = null;
        private _touchStartX: number = 0;
        private _touchStartY: number = 0;
        // Tracks active touch input, more reliable than $.isTouchCapable() on hybrid devices.
        _lastInteractionWasTouch: boolean = false;

        bindEvents() {
            var view = this.view;
            var map = this.map;

            this._mapEventListener.push(google.maps.event.addListener(map, 'mousedown', (event: google.maps.MouseEvent) => {
                this.viewModel.currentTool.isDragging = false;
                this.lastMouseDownEvent = event;
                this.viewModel.currentTool.onClick(event, this);
            }));

            this._mapEventListener.push(google.maps.event.addListener(map, 'mouseup', (event: google.maps.MouseEvent) => {
                this.viewModel.currentTool?.onMouseUp(event, this);
            }));

            // GM mousemove listener removed: it stops firing after rapid left clicks probably due to browser selection capture.
            // Replaced by the native DOM mousemove listener below, which uses GetLatLngFromMouseEvent to produce equivalent lat/lng.

            this._mapEventListener.push(google.maps.event.addListener(map, 'drag', (event: google.maps.MouseEvent) => {
                this.viewModel.currentTool.isDragging = true;
            }));

            this.keyDownHandler = (e: KeyboardEvent) => {
                const key = e.key;
                switch (key) {
                    case 'Shift':
                        this.shiftDown = true;
                        break;
                    case 'Control':
                        this.ctrlDown = true;
                        if (this.hasFocus)
                            e.preventDefault();
                        break;
                    case 'Alt':
                        this.altDown = true;
                        if (this.hasFocus)
                            e.preventDefault();
                        break;
                    case ' ':
                        this.spaceDown = true;
                        break;
                    case 'ArrowLeft':
                    case 'ArrowUp':
                    case 'ArrowRight':
                    case 'ArrowDown':
                        if (this.hasFocus) {

                            var dir: Point2D;

                            switch (key) {
                                case 'ArrowLeft':
                                    dir = new Point2D(-1, 0);
                                    break;
                                case 'ArrowUp':
                                    dir = new Point2D(0, 1);
                                    break;
                                case 'ArrowRight':
                                    dir = new Point2D(1, 0);
                                    break;
                                case 'ArrowDown':
                                    dir = new Point2D(0, -1);
                                    break;
                            }

                            if (this.shiftDown)
                                dir = Helperline.SnapDirection(dir, this);

                            var off = dir.mul(this.viewModel.keyBoardSteps.internalValue * 0.001);

                            if (this.viewModel.selection.some(sel => sel.typeName === this.viewModel.layer.referenceLayer.typeName)) {
                                this.viewModel.foreachItem(sel => {
                                    if (sel instanceof ShapeData && !sel.controlledByParent) {
                                        sel.moveByOffset(off);
                                        sel.update();
                                    }
                                });
                            } else {
                                this.viewModel.foreachSelected(sel => {
                                    sel.moveByOffset(off);
                                    sel.update();
                                });
                            }

                            return;
                        }
                        break;
                }
                if (this.hasFocus)
                    this.viewModel.currentTool.onKeyDown(key, this);
            };

            this.keyUpHandler = (e: KeyboardEvent) => {
                const key = e.key;
                switch (key) {
                    case 'Shift':
                        this.shiftDown = false;
                        break;
                    case 'Control':
                        this.ctrlDown = false;
                        if (this.hasFocus)
                            e.preventDefault();
                        break;
                    case 'Alt':
                        this.altDown = false;
                        if (this.hasFocus)
                            e.preventDefault();
                        break;
                    case ' ':
                        this.spaceDown = false;
                        break;
                    case 'Delete':
                        if (this.hasFocus)
                            this.deleteSelection();
                        return;
                    case 'Escape':
                        this._onEscapeKey();
                        return;
                }
                if (this.hasFocus)
                    this.viewModel.currentTool.onKeyUp(key, this);
            };

            this.mouseDownHandler = (e: MouseEvent) => {
                this.hasFocus = false;
            };

            this.mouseUpHandler = (e: any | MouseEvent | TouchEvent) => {
                this.isViewMouseDown = false;
                let firstTouchPoint = null;
                if (e.touches && e.touches[0])
                    firstTouchPoint = e.touches[0];
                if (firstTouchPoint == null && e.changedTouches && e.changedTouches[0])
                    firstTouchPoint = e.changedTouches[0];
                if (firstTouchPoint) {
                    e.clientX = firstTouchPoint.clientX
                    e.clientY = firstTouchPoint.clientY;
                    e.pageX = firstTouchPoint.pageX;
                    e.pageY = firstTouchPoint.pageY;
                    e.screenX = firstTouchPoint.screenX;
                    e.screenY = firstTouchPoint.screenY;
                }
                this.viewModel.onMouseup(e);

                if ($.isTouchCapable()) {
                    // Use touch movement distance instead of isDragging to detect taps.
                    // Small finger movements can trigger map.drag.
                    const dx = (e.pageX || 0) - this._touchStartX;
                    const dy = (e.pageY || 0) - this._touchStartY;
                    const isTap = dx * dx + dy * dy < 15 * 15;

                    if (isTap) {
                        const latLng = this.GetLatLngFromMouseEvent(e);
                        const toolName = this.viewModel.selectedToolName;
                        const tool = this.viewModel.currentTool as any;

                        if (latLng && toolName === 'SimpleRidgeTool') {
                            // map.mouseup is unreliable on mobile; drive placement from the DOM touchend.
                            tool.onMousemove?.({ latLng } as any, this);
                            tool._doPlacement?.({ latLng } as any, this);
                        } else if (toolName === 'SelectTool') {
                            // Mobile fallback: map.drag may suppress poly.click on minor touch movement.
                            // Use touchend to select the roof area after clearSelection has completed.
                            const hId = this.viewModel.hoveredId;
                            if (hId && this.viewModel.instances[hId]) {
                                const data = this.viewModel.instances[hId];
                                if (data instanceof ShapeData && !data._isDisposed && !data.locked) {
                                    const capturedData = data;
                                    const capturedLatLng = latLng;
                                    setTimeout(() => {
                                        this.viewModel.onSelectableClick(capturedData, { latLng: capturedLatLng } as any);
                                    }, 0);
                                }
                            }
                        }
                    }
                    // Reset so mouse clicks after this touch gesture are not treated as touch.
                    this._lastInteractionWasTouch = false;
                } else {
                    // Desktop fallback: poly.click may be lost after a map drag.
                    // Use mouseup to handle tap-based selection.
                    const dx = (e.pageX || 0) - this._touchStartX;
                    const dy = (e.pageY || 0) - this._touchStartY;
                    const isTap = dx * dx + dy * dy < 15 * 15;

                    // Only apply this fallback after a map drag, when poly.click may be suppressed.
                    // Normal clicks continue to use the standard poly.click path.
                    if (isTap && this.viewModel.selectedToolName === 'SelectTool' && this.viewModel.currentTool.isDragging) {
                        // Do not reset isDragging here.
                        // Resetting it would clear the selection below.
                        const latLng = this.GetLatLngFromMouseEvent(e);
                        if (latLng) {
                            const buildingTypeName = (window as any).BuildingTypeName;
                            const hits = this.getPolygonsByPoint(latLng)
                                .map(p => p.userData as ShapeData)
                                .filter(d => d instanceof ShapeData && !d._isDisposed && !d.locked);
                            // Select the building and let selectChildren choose the roof area.
                            // The building must remain selected to preserve the child selection.
                            const target = hits.find(d => d.typeName === buildingTypeName) ?? hits[0];
                            if (target) {
                                // setTimeout(0) so this runs after SelectTool.onMouseUp.
                                setTimeout(() => {
                                    this.viewModel.onSelectableClick(target, { latLng } as any);
                                }, 0);
                            }
                        }
                    }
                }
            };

            this.mouseMoveHandler = (e: any | MouseEvent | TouchEvent) => {
                let firstTouchPoint = null;
                if (e.touches && e.touches[0])
                    firstTouchPoint = e.touches[0];
                if (firstTouchPoint == null && e.changedTouches && e.changedTouches[0])
                    firstTouchPoint = e.changedTouches[0];
                if (firstTouchPoint) {
                    e.clientX = firstTouchPoint.clientX
                    e.clientY = firstTouchPoint.clientY;
                    e.pageX = firstTouchPoint.pageX;
                    e.pageY = firstTouchPoint.pageY;
                    e.screenX = firstTouchPoint.screenX;
                    e.screenY = firstTouchPoint.screenY;
                }

                this.viewModel.onMousemove(e);
                const latLng = this.GetLatLngFromMouseEvent(e);
                if (latLng)
                    this.viewModel.currentTool.onMousemove({ latLng } as any, this);
                this.isViewMouseMoving = true;
            };

            this.viewMouseDownHandler = (e: any | MouseEvent | TouchEvent) => {
                this.isViewStartMoving = false;
                this.isViewMouseDown = true;
                this.isViewMouseMoving = false;

                let firstTouchPoint = null;
                if (e.touches && e.touches[0])
                    firstTouchPoint = e.touches[0];
                if (firstTouchPoint == null && e.changedTouches && e.changedTouches[0])
                    firstTouchPoint = e.changedTouches[0];
                if (firstTouchPoint) {
                    e.clientX = firstTouchPoint.clientX
                    e.clientY = firstTouchPoint.clientY;
                    e.pageX = firstTouchPoint.pageX;
                    e.pageY = firstTouchPoint.pageY;
                    e.screenX = firstTouchPoint.screenX;
                    e.screenY = firstTouchPoint.screenY;
                    this._touchStartX = firstTouchPoint.pageX;
                    this._touchStartY = firstTouchPoint.pageY;
                    this._lastInteractionWasTouch = true;
                } else {
                    // Record mouse press position for tap-vs-pan detection in mouseUpHandler.
                    this._touchStartX = (e as MouseEvent).pageX || 0;
                    this._touchStartY = (e as MouseEvent).pageY || 0;
                }
                this.hasFocus = true;
                var viewModel = this.viewModel,
                    hoveredId = this.viewModel.hoveredId;

                if ($.isTouchCapable()) {
                    let latLng = this.GetLatLngFromMouseEvent(e);
                    let polys = this.getPolygonsByPoint(latLng);
                    if (polys && polys.length) {
                        hoveredId = polys[0].userData.id;
                        this.viewModel.hoveredId = hoveredId;
                    }
                    else {
                        if (hoveredId && viewModel.instances[hoveredId]) {
                            let data = viewModel.instances[hoveredId];
                            hoveredId = null;
                            this.viewModel.hoveredId = hoveredId;
                        }
                    }
                }

                if (hoveredId && viewModel.instances[hoveredId]) {
                    var data = viewModel.instances[hoveredId];
                    if (data instanceof ShapeData && !data._isDisposed)
                        this.viewModel.onPolygonMousedown(data.poly, e);
                }

            };

            document.addEventListener('keydown', this.keyDownHandler);
            window.addEventListener('keyup', this.keyUpHandler, true);

            if (!$.isTouchCapable()) {
                document.addEventListener('mousedown', this.mouseDownHandler, true);
                view.addEventListener('mousedown', this.viewMouseDownHandler, true);
                view.addEventListener('mousemove', this.mouseMoveHandler, true);
                document.addEventListener('mouseup', this.mouseUpHandler, true);
            }
            else {
                view.addEventListener('touchstart', this.viewMouseDownHandler, true);
                view.addEventListener('touchmove', this.mouseMoveHandler, true);
                view.addEventListener('touchend', this.mouseUpHandler, true);
            }

        }

        GetLatLngFromMouseEvent(e: MouseEvent): google.maps.LatLng {
            var map = this.map;
            var scale = Math.pow(2, map.getZoom());
            var projection = map.getProjection();
            var offset = map.getDiv().getBoundingClientRect();
            var mousePixels = new google.maps.Point(e.pageX - offset.left, e.pageY - offset.top);
            var mapBounds = map.getBounds();
            if (!mapBounds)
                return null;
            var mapNE = mapBounds.getNorthEast();
            var mapSW = mapBounds.getSouthWest();

            var mapNW = new google.maps.LatLng(mapNE.lat(), mapSW.lng());
            var pNW = projection.fromLatLngToPoint(mapNW);
            var point = new google.maps.Point(((pNW.x * scale) + mousePixels.x) / scale, ((pNW.y * scale) + mousePixels.y) / scale);

            return projection.fromPointToLatLng(point, false);
        }

        GetPoint2DFromMouseEvent(e: MouseEvent): Point2D {
            return LatLng.GMLatLngToPoint2D(this.GetLatLngFromMouseEvent(e));
        }

        getBoundsFromPolygons(polys: IGoogleMapsPolygon[]) {
            var bounds = new google.maps.LatLngBounds();
            polys.forEach(poly => {
                var paths = poly.getPaths();
                paths.forEach(path => {
                    path.forEach(latLng => {
                        bounds.extend(latLng);
                    });
                });
            });
            return bounds;
        }

        getBoundsFromPolygon(poly: IGoogleMapsPolygon) {
            var bounds = new google.maps.LatLngBounds();
            var paths = poly.getPaths();
            paths.forEach(path => {
                path.forEach(latLng => {
                    bounds.extend(latLng);
                });
            });
            return bounds;
        }

        clearSelection() {
            var viewModel = this.viewModel;
            viewModel.selection.splice(0, viewModel.selection.length).forEach(item => {

                item.selected = false;

                // Change the color of the SouthMarker depending on the selection of the roof.
                if (item.typeName && (item.typeName == window.RoofTypeName)) {
                    var shapeDataItem: ShapeData = item as ShapeData;
                    if (shapeDataItem.southMarker) {
                        shapeDataItem.southMarker.setSelected(false);
                    }
                }
            });
        }

        deleteAll() {
            var viewModel = this.viewModel;
            viewModel.layer.all.forEach(layer => {
                this.deleteSelectables(layer.polygons.map(poly => poly.userData as ShapeData));
            });
        }

        clear() {
            this.viewModel.clear();
        }

        deleteRoofClick(roof: ISelectableItem) {
            if (roof && confirm("Delete roof?"))
                this.deleteSelectable(roof);
        }

        activateTemplateMatchingClick() {
            var selection = this.viewModel.selection;
            var selectionNames: Array<string> = []
            selection.forEach(item => {
                if (item instanceof ShapeData) {
                    var shapeData = item as ShapeData;
                    var title = shapeData.title;
                    selectionNames.push(title);
                }
            });

            if (selectionNames.length === 0) {
                DManager.showErrorMessage($('#detectInterferenceErrorMsg').html());
                return;
            }

            var mapType = "" + this.map.getMapTypeId(),
                isGoogleHD = mapType === "Google HD";

            var data: SolarProTool.MapDrawerData = this.getDefaultMapDrawerData();

            if (isGoogleHD) {

                let bd = new MapDrawing.BoundsLatLng();

                this.getAllPolygons().filter(poly => poly.userData && !poly._isDisposed).forEach(poly => {
                    var shapeData = poly.userData as ShapeData;
                    bd.Expand(shapeData.bounds);
                });

                let w = bd.Width,
                    h = bd.Height;

                if (w > 0 && w < 1000 && h > 0 && h < 1000) {
                    var ocr = this.ocrManager.ocr,
                        canvas = document.createElement("canvas"),
                        zoom: number,
                        pxSize = 1024,
                        sizeFactor = Math.min(pxSize / w, pxSize / h),
                        maxSize = Math.max(w, h),
                        pxWidth = Math.round(w * sizeFactor),
                        pxHeight = Math.round(h * sizeFactor);

                    if (maxSize > 500)
                        zoom = 18;
                    else if (maxSize > 250)
                        zoom = 19;
                    else
                        zoom = 23;

                    canvas.width = pxWidth;
                    canvas.height = pxHeight;

                    LoaderManager.addLoadingJob();

                    ocr.requestRender(bd, zoom, () => canvas, (success) => {
                        LoaderManager.finishLoadingJob();

                        if (success && canvas && typeof canvas.toDataURL == "function") {
                            data.MapsImageData = canvas.toDataURL("image/png");
                            data.MapsImageMinLatitude = bd.Min.Latitude;
                            data.MapsImageMinLongitude = bd.Min.Longitude;
                            data.MapsImageMaxLatitude = bd.Max.Latitude;
                            data.MapsImageMaxLongitude = bd.Max.Longitude;
                        }

                        this.getMatchedInterferences(data, selectionNames);
                    }, pxWidth, pxHeight);

                    return;
                }
            }

            this.getMatchedInterferences(data, selectionNames);
        }

        getMatchedInterferences(data: SolarProTool.MapDrawerData, selectionNames: Array<string>) {
            var interferenceCounter: number = data.Shapes.filter(shape => shape.TypeName === this.viewModel.layer.interference.typeName).length;
            SolarProTool.Ajax("WebServices/MapServices.asmx").Call("GetMatchedInterferences").Data({ data: data, selectionNames: selectionNames }).CallBack(res => {

                let interferences: SolarProTool.MapShape[] = res;
                interferences.forEach(interference => {
                    var paths: google.maps.LatLng[][] = [];

                    paths.push(interference.borders[0].points.map(p => {
                        const latLng = new google.maps.LatLng(p.latitude, p.longitude);
                        return latLng;
                    }));

                    let poly = new google.maps.Polygon({
                        paths: paths
                    });

                    interferenceCounter++;
                    poly.userData = new ShapeData(this, poly, spt.Utils.GenerateGuid(), this.viewModel.layer.interference.getNewName(interferenceCounter), this.viewModel.layer.interference.typeName, 0);

                    this.onOverlaycomplete(poly, true);
                });
            });

        }
		
		drawNorthCompass() {
			const image = new Image();

			image.src = hostPath + "/content/images/Arrows/north_compass.png";
			image.width = 90;
			image.height = 90;
			image.alt = "N";
			image.classList.add("north-compass");

			this.mapsViewWrapper.appendChild(image);
		}

        deleteAllInterferencesClick() {
            var interferenceTypeName = this.viewModel.layer.interference.typeName;
            var viewModel = this.viewModel;
            viewModel.layer.all.forEach(layer => {
                var polygonsUserData = layer.polygons.map(poly => poly.userData as ShapeData);
                var polygonsUserDataFiltered = polygonsUserData.filter(userData => userData.typeName === interferenceTypeName)
                this.deleteSelectables(polygonsUserDataFiltered);
            });
        }
        setInterferenceName(data) {
            this.viewModel.layer.interference.typeName = data;
        }
        activateObjectDetectorClick() {
            var mapType = "" + this.map.getMapTypeId(),
                isGoogleHD = mapType === "Google HD";

            var data: SolarProTool.MapDrawerData = this.getDefaultMapDrawerData();

            if (isGoogleHD) {

                let bd = new MapDrawing.BoundsLatLng();

                this.getAllPolygons().filter(poly => poly.userData && !poly._isDisposed).forEach(poly => {
                    var shapeData = poly.userData as ShapeData;
                    bd.Expand(shapeData.bounds);
                });

                let w = bd.Width,
                    h = bd.Height;

                if (w > 0 && w < 1000 && h > 0 && h < 1000) {
                    var ocr = this.ocrManager.ocr,
                        canvas = document.createElement("canvas"),
                        zoom: number,
                        pxSize = 1024,
                        sizeFactor = Math.min(pxSize / w, pxSize / h),
                        maxSize = Math.max(w, h),
                        pxWidth = Math.round(w * sizeFactor),
                        pxHeight = Math.round(h * sizeFactor);

                    if (maxSize > 500)
                        zoom = 18;
                    else if (maxSize > 250)
                        zoom = 19;
                    else
                        zoom = 23;

                    canvas.width = pxWidth;
                    canvas.height = pxHeight;

                    LoaderManager.addLoadingJob();

                    ocr.requestRender(bd, zoom, () => canvas, (success) => {
                        LoaderManager.finishLoadingJob();

                        if (success && canvas && typeof canvas.toDataURL == "function") {
                            data.MapsImageData = canvas.toDataURL("image/png");
                            data.MapsImageMinLatitude = bd.Min.Latitude;
                            data.MapsImageMinLongitude = bd.Min.Longitude;
                            data.MapsImageMaxLatitude = bd.Max.Latitude;
                            data.MapsImageMaxLongitude = bd.Max.Longitude;
                        }

                        this.getInterferencePredictions(data);
                    }, pxWidth, pxHeight);

                    return;
                }
            }

            this.getInterferencePredictions(data);
        }

        getInterferencePredictions(data: SolarProTool.MapDrawerData) {
            var interferenceCounter: number = data.Shapes.filter(shape => shape.TypeName === this.viewModel.layer.interference.typeName).length;
            SolarProTool.Ajax("WebServices/MapServices.asmx").Call("GetInterferencePredictions").Data({ data: data }).CallBack(res => {

                let interferences: SolarProTool.MapShape[] = res;
                interferences.forEach(interference => {
                    var paths: google.maps.LatLng[][] = [];

                    paths.push(interference.borders[0].points.map(p => {
                        const latLng = new google.maps.LatLng(p.latitude, p.longitude);
                        return latLng;
                    }));

                    let poly = new google.maps.Polygon({
                        paths: paths
                    });

                    interferenceCounter++;
                    poly.userData = new ShapeData(this, poly, spt.Utils.GenerateGuid(), this.viewModel.layer.interference.getNewName(interferenceCounter), this.viewModel.layer.interference.typeName, 0);

                    this.onOverlaycomplete(poly, true);
                });
            });
        }

        deleteSelection() {
            var viewModel = this.viewModel;
            var items = viewModel.selection.splice(0, viewModel.selection.length);
            this.deleteSelectables(items);
        }

        deleteSelectables(items: ISelectableItem[]) {
            if (!items)
                return;

            this.viewModel.cleanUpDragInfo();

            items.forEach(item => {
                this.deleteSelectable(item);
            });

            if (this.viewModel.layer.all.every(layer => !layer.polygons.length))
                this.viewModel.detailsViewVisible = false;
        }

        deleteSelectableClick(item: ISelectableItem) {
            if (!item.locked)
                this.deleteSelectable(item);
        }

        deleteSelectable(item: ISelectableItem) {
            if (item) {
                this.removeItemFromSelection(item);

                item.remove(this);

                if (item.typeName !== window.InterfernceLayerName)
                    this.autoSelectLayer();
            }
        }

        exportShapes(): SolarProTool.MapShape[] {

            if (!this.viewModel.layer.referenceLayer.polygons.length)
                return [];

            let referenceData = this.regenerateReferencePoly();

            if (!referenceData)
                return null;

            let referenceOrientation = referenceData.southMarker ? referenceData.southMarker.orientation : 0,
                referenceOrigin = LatLng.FromPoint2D(referenceData.getOrientedOrigin());

            var useCustomHeightsArray = this.getAllPolygons().filter(poly => poly.userData && !poly._isDisposed && (poly.userData as ShapeData).typeName === window.BuildingTypeName && (poly.userData as ShapeData).mType === 'ShapeData').map(poly => {
                return (poly.userData as ShapeData).useCustomHeights;
            });
            var useCustomHeights = false;

            if (useCustomHeightsArray.length > 0) {
                useCustomHeights = useCustomHeightsArray[0];
            }
            var customHeights: Map<string, number> = null;

            if (useCustomHeights) {
                var customHeightsOfPolygons = this.getAllPolygons().filter(poly => poly.userData && !poly._isDisposed && (poly.userData as ShapeData).customHeights.size > 0).map(poly => {
                    return (poly.userData as ShapeData).customHeights;
                });
                if (customHeightsOfPolygons.length > 0) {
                    customHeights = customHeightsOfPolygons[0];
                }
            }

            var result = this.getAllPolygons().filter(poly => poly.userData && !poly._isDisposed).map(poly => {
                return this.exportShape(poly.userData as ShapeData, referenceData, referenceOrigin, referenceOrientation, customHeights);

                //var polys: SolarProTool.MapPolygon[] = [];

                //var data = poly.userData as ShapeData;

                //data.regenerate();

                //var bd = new BoundsLatLng();

                //poly.getPaths().forEach((path) => {
                //    var lls = LatLng.FromGMLatLngArray(path);
                //    bd.ExpandByLatLngs(lls);
                //    //var poly = this.pathToMapPolygon(lls, data.southMarker ? data.southMarker.orientation : buildingOrientation, buildingOrigin, data.height, data.slope, data.useProjection);
                //    var poly = this.pathToMapPolygon(lls, data.southMarker ? data.southMarker.orientation : referenceOrientation, data.southMarker ? LatLng.FromPoint2D(data.getOrientedOrigin()) : referenceOrigin, data.height, data.slope, referenceData.useProjection);
                //    if (poly)
                //        polys.push(poly);
                //});

                //var spPolylines: SolarProTool.MapPolygon[] = [],
                //    cutPolylines: SolarProTool.MapPolygon[] = [];

                //if (data.separationPolylines && data.separationPolylines.length) {
                //    data.separationPolylines.forEach(sp => {
                //        var mp = this.pathToMapPolygon(
                //            LatLng.FromGMLatLngArray(sp.polyline.getPath()),
                //            data.southMarker ? data.southMarker.orientation : referenceOrientation,
                //            data.southMarker ? LatLng.FromPoint2D(data.getOrientedOrigin()) : referenceOrigin,
                //            referenceData.height,
                //            referenceData.slope,
                //            referenceData.useProjection,
                //            true);
                //        if (sp.isCutting)
                //            cutPolylines.push(mp);
                //        else
                //            spPolylines.push(mp);
                //    });
                //}

                //let result: SolarProTool.MapShape = {
                //        IdString: data.id,
                //        TypeName: data.typeName,
                //        Title: data.title,
                //        borders: polys,
                //        IsParallel: data.isParallel,
                //        mapSouthMarker: data.southMarker ? data.southMarker.getLatLngOrientation() : null,
                //        IsActive: data.isActive,
                //        separationPolylines: spPolylines,
                //        cuttingPolylines: cutPolylines,
                //        SlopeOverride: data.slopeOverride
                //    };
                //return result;
            });
            return result;
        }

        exportShape(data: ShapeData, referenceData?: ShapeData, referenceOrigin?: LatLng, referenceOrientation?: number, customHeights?: Map<string, number>): SolarProTool.MapShape {
            data.regenerate();

            if (!referenceData) {
                if (this.viewModel.layer.referenceLayer.typeName === data.typeName) {
                    referenceData = data;
                }
                else {
                    if (!this.viewModel.layer.referenceLayer.polygons.length)
                        return null;

                    referenceData = this.regenerateReferencePoly();

                    if (!referenceData)
                        return null;
                }
            }

            if (!referenceOrigin) {
                referenceOrigin = LatLng.FromPoint2D(referenceData.getOrientedOrigin());
            }

            if (referenceOrientation === null || isNaN(referenceOrientation)) {
                referenceOrientation = referenceData.southMarker ? referenceData.southMarker.orientation : 0;
            }

            var polys: SolarProTool.MapPolygon[] = [],
                poly = data.poly;

            var bd = new BoundsLatLng();
            
            poly.getPaths().forEach((path) => {
                var lls = LatLng.FromGMLatLngArray(path);
                bd.ExpandByLatLngs(lls);
                //var poly = this.pathToMapPolygon(lls, data.southMarker ? data.southMarker.orientation : buildingOrientation, buildingOrigin, data.height, data.slope, data.useProjection);
                var poly = this.pathToMapPolygon(lls, data.southMarker ? data.southMarker.orientation : referenceOrientation, data.southMarker ? LatLng.FromPoint2D(data.getOrientedOrigin()) : referenceOrigin, data.height, data.slope, referenceData.useProjection);
                if (poly)
                    polys.push(poly);
            });

            var spPolylines: SolarProTool.MapPolygon[] = [],
                cutPolylines: SolarProTool.MapPolygon[] = [];

            if (data.separationPolylines && data.separationPolylines.length) {
                data.separationPolylines.forEach(sp => {
                    var mp = this.pathToMapPolygon(
                        LatLng.FromGMLatLngArray(sp.polyline.getPath()),
                        data.southMarker ? data.southMarker.orientation : referenceOrientation,
                        data.southMarker ? LatLng.FromPoint2D(data.getOrientedOrigin()) : referenceOrigin,
                        referenceData.height,
                        referenceData.slope,
                        referenceData.useProjection,
                        true);
                    if (sp.isCutting)
                        cutPolylines.push(mp);
                    else
                        spPolylines.push(mp);
                });
            }

            let customHeightsNumberArray: Array<number> = [];
            let border: SolarProTool.MapPolygon = polys[0];
            if (customHeights) {
                border.points.forEach(p => {
                    let key: string = toFixedWithoutRounding(p.latitude, 7) + "," + toFixedWithoutRounding(p.longitude, 7);
                    if (customHeights.has(key)) {
                        customHeightsNumberArray.push(customHeights.get(key));
                    } else {
                        customHeightsNumberArray.push(null);
                    }
                });
            }

            let result: SolarProTool.MapShape = {
                IdString: data.id,
                TypeName: data.typeName,
                Title: data.title,
                RotationalAngle: data.rotationAngle,
                borders: polys,
                IsParallel: data.isParallel,
                mapSouthMarker: data.southMarker ? data.southMarker.getLatLngOrientation() : null,
                IsActive: data.isActive,
                separationPolylines: spPolylines,
                cuttingPolylines: cutPolylines,
                SlopeOverride: data.slopeOverride,
                CustomHeights: customHeightsNumberArray,
                UseCustomSouthMarker: data.useCustomSouthMarker,
                LeaveRoofAreaUntouched: data.leaveRoofAreaUntouched,
                UseSimpleRidgeTool: data.useSimpleRidgeTool,
                DeletedFaceCentroids: (data.deletedFaceCentroids ?? []).map(ll => ({ Latitude: ll.Latitude, Longitude: ll.Longitude })),
                InactiveFaceCentroids: (data.inactiveFaceCentroids ?? []).map(ll => ({ Latitude: ll.Latitude, Longitude: ll.Longitude })),
                IsInactiveFace: !!data.isInactiveFace
            };
            return result;
        }

        importShape(shape: SolarProTool.MapShape, bounds?: google.maps.LatLngBounds, customHeights?: Map<string, number>): ShapeData {
            const paths: google.maps.LatLng[][] = [];
            if (!bounds) {
                bounds = new google.maps.LatLngBounds();
            }

            let h = 0;
            let slope = 0;
            let useProjection = !this.isFacade;

            shape.borders.forEach(poly => {
                paths.push(poly.points.map(p => {
                    const latLng = new google.maps.LatLng(p.latitude, p.longitude);
                    if (p.z > h)
                        h = p.z;
                    bounds.extend(latLng);
                    return latLng;
                }));
                slope = poly.slope || 0;
                useProjection = poly.useProjection === undefined ? true : !!poly.useProjection;
                
                if (shape.IdString == $('#Roof_Id').val()){
                    slope = spt.Utils.GetFloatFromInput("#Roof_Angle", {min: 0, max: 100, precision: 2, notImperial: true, isFeet: false});

                    $(document).ready(function() {
                        $("#mapViewerRoofAngle").val(slope);
                    });
                }
            });
            
            const layer = this.viewModel.layer.typeName[shape.TypeName],
                shapeStyle = layer ? layer.shapeStyle : this.shapeStyle;

            const gPoly = new google.maps.Polygon($.extend({}, {
                map: this.map,
                clickable: !this.zoomOnlyMode,
                draggable: false,
                editable: false,
                paths: paths
            }, shapeStyle) as google.maps.PolygonOptions);

            let isFrozen = false;

            if (shape.IdString && this.viewModel.hasInstance(shape.IdString)) {
                const prev = this.viewModel.instances[shape.IdString] as ShapeData;
                isFrozen = !prev.controlledByParent && prev.frozen;
                prev.remove(this);
                this.viewModel.removeInstance(shape.IdString);
            }

            const shapeData = new ShapeData(this, gPoly as any, shape.IdString, shape.Title, shape.TypeName, shape.RotationalAngle, customHeights);

            shapeData.slopeOverride = !!shape.SlopeOverride;
            shapeData.isActive = !!shape.IsActive;

            shapeData.slope = slope;
            shapeData.customSlope = slope;
            
            if (shapeData.typeName === window.BuildingTypeName) { 
                shapeData.slope = 0; 
                shapeData.customSlope = 0;

                if (shapeData.height <= 0 && h > 0) {
                    shapeData.height = h;
                }
            }
            shapeData.useProjection = useProjection;
            shapeData.isParallel = !!shape.IsParallel;
            if (isFrozen)
                shapeData.frozen = true;

            (gPoly as any).userData = shapeData;

            if (shape.mapSouthMarker) {
                const pos = new LatLng(shape.mapSouthMarker.Latitude, shape.mapSouthMarker.Longitude);
                shapeData.southMarker = new SouthMarker(pos, shape.mapSouthMarker.Orientation, true, this);
            }

            if (shape.separationPolylines && shape.separationPolylines.length) {
                shape.separationPolylines.forEach(poly => {
                    const arr = poly.points.map(p => {
                        const latLng = new google.maps.LatLng(p.latitude, p.longitude);
                        if (p.z > h)
                            h = p.z;
                        bounds.extend(latLng);
                        return latLng;
                    });
                    const separationPolyline = new SeparationPolyline(this, shapeData, null, arr);
                });
            }

            if (shape.cuttingPolylines && shape.cuttingPolylines.length) {
                shape.cuttingPolylines.forEach(poly => {
                    const arr = poly.points.map(p => {
                        const latLng = new google.maps.LatLng(p.latitude, p.longitude);
                        if (p.z > h)
                            h = p.z;
                        bounds.extend(latLng);
                        return latLng;
                    });
                    if (arr.length > 1) {
                        var cuttingPolyline = new SeparationPolyline(this, shapeData, null, arr, true);
                    }
                });
            }
            
            if(shapeData.typeName !== window.BuildingTypeName) {
                shapeData.height = h;
            }

            shapeData.useCustomSouthMarker = shape.UseCustomSouthMarker;
            shapeData.leaveRoofAreaUntouched = !!(shape.LeaveRoofAreaUntouched ?? (shape as any).leaveRoofAreaUntouched);
            shapeData.useSimpleRidgeTool = shape.UseSimpleRidgeTool;
            // Restore deleted-areas centroids before regenerate().
            // Ensures deleted SimpleRidge areas stay deleted.
            shapeData.deletedFaceCentroids = ((shape.DeletedFaceCentroids ?? []) as Array<{ Latitude: number; Longitude: number }>)
                .map(p => new LatLng(p.Latitude, p.Longitude));
            // Restore deactivated-area centroids before regenerate().
            // Ensures deactivated areas stay deactivated after reload.
            shapeData.inactiveFaceCentroids = ((shape.InactiveFaceCentroids ?? []) as Array<{ Latitude: number; Longitude: number }>)
                .map(p => new LatLng(p.Latitude, p.Longitude));
            // GIS buildings must not regenerate imported roof areas.
            // Set this before addPolygon, which triggers regeneration.
            if (shapeData.typeName === (window as any).BuildingTypeName) {
                shapeData.leaveRoofAreaUntouched = true;
            }

            this.addPolygon(gPoly as any);

            return shapeData;
        }

        importShapes(shapes: SolarProTool.MapShape[]): BoundsLatLng {
            if (shapes && shapes.length) {
                var customHeights: Map<string, number> =  this.createCustomHeightsIfDifferentZValues(shapes);

                var bounds = new google.maps.LatLngBounds();

                var buildings: ShapeData[] = [];

                var buildingShapes = shapes.filter(shape => shape.TypeName === window.BuildingTypeName);

                buildingShapes.forEach((bs, i) => {
                    var bd = this.importShape(bs, bounds, customHeights);
                    // GIS buildings must never be frozen
                    // Clear any inherited frozen state
                    if (bd) {
                        bd.frozen = false;
                        buildings.push(bd);
                    }
                });

                // isGisImport applies only to 3D-tile buildings.
                // Manual buildings still require parent-child assignment.
                const isGisImport = buildingShapes.some(bs =>
                    !!(bs.LeaveRoofAreaUntouched ?? (bs as any).leaveRoofAreaUntouched));

                shapes.filter(shape => shape.TypeName !== window.BuildingTypeName).forEach(shape => {
                    // For GIS imports, only restore roof shapes.
                    // Ignore stale non-roof shapes from previous regeneration.
                    if (isGisImport && shape.TypeName !== window.RoofTypeName) {
                        return;
                    }

                    // Set LeaveRoofAreaUntouched before importShape.
                    // Prevents regeneration from creating child shapes.
                    if (isGisImport && shape.TypeName === window.RoofTypeName) {
                        (shape as any).LeaveRoofAreaUntouched = true;
                    }

                    var shapeData = this.importShape(shape, bounds, customHeights);

                    // GIS imports do not use parent-child roof assignments.
                    // For manual buildings, each roof must be assigned to its actual building.
                    if (!isGisImport && buildings.length && shape.TypeName === window.RoofTypeName) {
                        const owner = this.findOwningBuilding(buildings, shapeData);
                        if (owner) {
                            owner.children.push(shapeData);
                            shapeData.parent = owner;
                        }
                    }
                });

                // Skip update for GIS buildings (leaveRoofAreaUntouched=true).
                // regenerate() may create child shapes on roof polygons and corrupt their state.
                buildings.forEach(b => {
                    if (!isGisImport) {
                        // Restore regenerate() behaviour for manual buildings by clearing leaveRoofAreaUntouched after import.
                        b.leaveRoofAreaUntouched = false;
                    }
                    if (!b.leaveRoofAreaUntouched) {
                        b.update();
                    }
                });


                if (!bounds.isEmpty())
                    return BoundsLatLng.FromGMLatLngBounds(bounds);
            }
            return new BoundsLatLng();
        }

        // Returns the building a restored roof belongs to.
        // For multiple buildings, uses containment and falls back to the nearest centroid.
        private findOwningBuilding(buildings: ShapeData[], roof: ShapeData): ShapeData | null {
            if (buildings.length <= 1) {
                return buildings[0] ?? null;
            }

            const roofPoly = roof.poly;
            if (!roofPoly) {
                return buildings[0];
            }

            const center = this.getBoundsFromPolygon(roofPoly).getCenter();

            const containing = buildings.find(b =>
                b.poly && google.maps.geometry.poly.containsLocation(center, b.poly as google.maps.Polygon));
            if (containing) {
                return containing;
            }

            let nearest: ShapeData = buildings[0];
            let nearestDist = Infinity;
            for (const b of buildings) {
                if (!b.poly) continue;
                const bCenter = this.getBoundsFromPolygon(b.poly).getCenter();
                const dist = google.maps.geometry.spherical.computeDistanceBetween(center, bCenter);
                if (dist < nearestDist) {
                    nearestDist = dist;
                    nearest = b;
                }
            }
            return nearest;
        }

        createCustomHeightsIfDifferentZValues(shapes: SolarProTool.MapShape[]): Map<string, number> {
            var customHeights: Map<string, number> = new Map();
            for (var i = 0; i < shapes.length; i++) {
                for (var j = 0; j < shapes[i].borders.length; j++) {
                    if (shapes[i].CustomHeights && shapes[i].CustomHeights.length > 0) {  
                        for (var k = 0; k < shapes[i].borders[j].points.length; k++) {
                            if (shapes[i].CustomHeights[k]) {
                                var z: number = shapes[i].CustomHeights[k];
                                var p = shapes[i].borders[j].points[k];
                                var key = toFixedWithoutRounding(p.latitude, 7) + "," + toFixedWithoutRounding(p.longitude, 7);
                                customHeights.set(key, z);
                            }
                        }
                    }
                }
            }
            if (customHeights.size == 0) {
                customHeights = null;
            }
            return customHeights;
        }

        addPolygonByData(data: PolyData) {
            var layer = this.viewModel.layer.typeName[data.typeName],
                shapeStyle = layer ? layer.shapeStyle : this.shapeStyle;

            var gPoly = new google.maps.Polygon($.extend({}, {
                map: this.map,
                clickable: !this.zoomOnlyMode,
                draggable: false,
                editable: false,
                paths: new google.maps.MVCArray(data.latLngs.map(lls => new google.maps.MVCArray(lls.map(ll => ll.ToGMLatLng()))))
            }, shapeStyle) as google.maps.PolygonOptions);

            var shapeData = new ShapeData(this, gPoly as any, data.id || spt.Utils.GenerateGuid(), data.title, data.typeName);

            shapeData.height = data.height;

            (gPoly as any).userData = shapeData;

            this.addPolygon(gPoly as any);
        }

        addPolygon(poly: IGoogleMapsPolygon): IGoogleMapsPolygon {
            var data = poly.userData as ShapeData;
            var layer = (data ? this.viewModel.layer.typeName[data.typeName] : null) || this.viewModel.currentLayer;

            if (layer) {
                layer.addPolygon(poly, this);
            } else {
                if (data)
                    data.dispose();
                else
                    poly.setMap(null);
                DManager.showErrorMessage("Can't add Polygon of unknown type.");
                return null;
            }

            return poly;
        }

        selectShapes(shapes: ISelectableItem[], forceSelection?: boolean, forceAdd?: boolean, forceRemove?: boolean) {

            var ctrlDown = this.ctrlDown;
            var shiftDown = this.shiftDown;

            if (((!forceAdd && !shiftDown && !ctrlDown) || forceSelection) && !forceRemove) {
                this.clearSelection();
            }

            shapes.forEach(s => this.doSelectSelectable(s, false, !forceRemove, forceRemove));
        }

        doSelectSelectable(item: ISelectableItem, forceSelection?: boolean, forceAdd?: boolean, forceRemove?: boolean) {
            if (!item || !item.getMap() || item.locked)
                return;
            var ctrlDown = this.ctrlDown,
                shiftDown = this.shiftDown;
            if (forceSelection) {
                ctrlDown = false;
                shiftDown = false;
            } else if (forceAdd) {
                ctrlDown = false;
                shiftDown = true;
            } else if (forceRemove) {
                ctrlDown = true;
                shiftDown = true;
            }
            //var data = shape.userData as ShapeData;
            //var layer = data ? viewModel.getLayerByTypeName(data.typeName) : null;
            //if (!layer)
            //    return;

            //var shapeHovered = true;

            if (this.eraseMode) {
                this.deleteSelectable(item);
                return;
            }

            var isSelected = item.selected;

            if (ctrlDown && !shiftDown) {
                //toogle selection
                if (isSelected) {
                    this.removeItemFromSelection(item);

                    //item.selected = false;
                    //shape.setEditable(false);
                    //shape.setDraggable(false);
                    //shape.setOptions(shapeHovered ? layer.shapeHoveredStyle : layer.shapeStyle);
                    //viewModel.selection.remove(s => s.id === item.id);
                } else {
                    this.addItemToSelection(item);

                    //item.selected = true;
                    //item.setEditable(true);
                    //item.setDraggable(true);
                    //item.setOptions(shapeHovered ? layer.shapeSelectedHoveredStyle : layer.shapeSelectedStyle);
                    //viewModel.selection.push(item);
                }
            } else if (!ctrlDown && shiftDown) {
                //only add to selection
                if (!isSelected) {
                    this.addItemToSelection(item);

                    //item.selected = true;
                    //item.setEditable(true);
                    //item.setDraggable(true);
                    //item.setOptions(shapeHovered ? layer.shapeSelectedHoveredStyle : layer.shapeSelectedStyle);
                    //viewModel.selection.push(item);
                }
            } else if (ctrlDown && shiftDown) {
                //only remove from selection
                if (isSelected) {
                    this.removeItemFromSelection(item);

                    //item.selected = false;
                    //item.setEditable(false);
                    //item.setDraggable(false);
                    //item.setOptions(shapeHovered ? layer.shapeHoveredStyle : layer.shapeStyle);
                    //viewModel.selection.remove(s => s.id === item.id);
                }
            } else {
                //select only this shape
                this.clearSelection();

                this.addItemToSelection(item);

                //item.selected = true;
                //item.setEditable(true);
                //item.setDraggable(true);
                //item.setOptions(shapeHovered ? layer.shapeSelectedHoveredStyle : layer.shapeSelectedStyle);
                //viewModel.selection.push(item);
            }
        }

        removeFromSelection(id: string) {
            if (id)
                this.viewModel.selection.remove(s => s.id === id).forEach(s => { s.selected = false; });
        }

        removeItemFromSelection(item: ISelectableItem) {
            if (item) {
                if (item.typeName) {
                    var layer = this.viewModel.layer.typeName[item.typeName];
                    if (layer)
                        layer.lastClickedIndex = -1;
                }
                this.removeFromSelection(item.id);
            }
        }

        addItemToSelection(item: ISelectableItem) {
            var selection = this.viewModel.selection;
            if (item && !item.selected && !item._isDisposed) {
                if (item.typeName) {
                    var layer = this.viewModel.layer.typeName[item.typeName];
                    if (layer)
                        layer.lastClickedIndex = -1;

                    // Change the color of the SouthMarker depending on the selection of the roof.
                    if (item.typeName == window.RoofTypeName) {
                        var shapeDataItem: ShapeData = item as ShapeData;
                        if (shapeDataItem.southMarker) {
                            shapeDataItem.southMarker.setSelected(true);
                        }
                    }
                }
                item.selected = true;
                selection.push(item);
            }
        }

        addItemsToSelection(items: ISelectableItem[]) {
            var selection = this.viewModel.selection;
            if (items && items.length)
                items = items.filter(item => !item.selected && !item._isDisposed);
            if (items && items.length) {
                items.forEach(item => {
                    item.selected = true;
                    if (item.typeName) {
                        var layer = this.viewModel.layer.typeName[item.typeName];
                        if (layer)
                            layer.lastClickedIndex = -1;
                    }
                });
                selection.push.apply(selection, items);
            }
        }

        deleteImportedImage() {

            var imgIds = this.viewModel.importedImages.map(img => img._id);

            if (!imgIds.length) {
                this.selectTool(null);
                return;
            }

            SolarProTool.Ajax("WebServices/MapServices.asmx").Call("DeleteImportedImages").Data({ ids: imgIds }).CallBack((result) => {
                this.selectTool(null);

                this.viewModel.currentImportedImageId = null;
                this.viewModel.importedImages.removeAll().forEach(im => {
                    im.setMap(null);
                });
            });
        }

        selectToolClick(toolName: string, subTool?: string) {

            (<any>window).lsSidebar.close('mapSettingsSlider');

            var viewModel = this.viewModel,
                tool = viewModel.toolIcons[toolName];

            if (tool && tool.disabled)
                return;

            // single or multi-roof mode 
            if (toolName === 'DrawTool'
                && this === (window as any).lsGoogleMaps?.getMapDrawer?.()
                && (window as any).lsGoogleMaps?.shouldPromptRoofModeBeforeDraw?.()) {
                (window as any).lsGoogleMaps?.requestRoofModeBeforeDraw?.();
                return;
            }

            let dropdownButton = $('#dropdownMenuToolbar' + toolName);
            let dropdownParent = dropdownButton.parent();
            let isLandscape = window.innerHeight <= window.innerWidth;

            let cssOrientation = isLandscape ? "dropright" : "dropdown";
            let cssOrientationOther = !isLandscape ? "dropright" : "dropdown";
            dropdownParent.removeClass(cssOrientationOther);
            dropdownParent.addClass(cssOrientation);

            if (tool && tool.subMenu && tool.subMenu.length) {
                if (!dropdownButton.data('init')) {
                    dropdownButton.dropdown();
                    dropdownButton.data('init', true);
                    dropdownButton.dropdown('toggle');
                }

                if (subTool)
                    dropdownButton.dropdown('toggle');
            }

            this.selectTool(toolName, subTool);

            // keep the roof-step info box in sync with the selected tool
            if (this === (window as any).lsGoogleMaps?.getMapDrawer?.()) {
                (window as any).lsGoogleMaps?.notifyManualRoofToolSelected?.(toolName);
            }
        }

        selectTool(toolName: string, subTool?: string) {
            var viewModel = this.viewModel,
                oldTool = viewModel.currentTool,
                tool = viewModel.toolIcons[toolName];

            viewModel.cleanUpDragInfo();

            if (!tool || tool.disabled) {
                toolName = "SelectTool";
                tool = viewModel.toolIcons[toolName];
            }

            if (oldTool)
                oldTool.deselect(this);

            viewModel.currentTool = tool;

            if (toolName === "SelectTool" || toolName === "EraserTool" || toolName === "Gis3DBuildingsTool" || toolName === "Unselect3DBuildingsTool") {
                this.getAllPolygons().forEach(poly => {
                    if (poly.userData) {
                        poly.userData.frozen = false;
                        poly.setOptions({ clickable: true });
                    }
                });
                this.viewModel.helperLines.forEach(hl => {
                    hl.frozen = false;
                });
            } else {
                this.getAllPolygons().forEach(poly => {
                    if (poly.userData) {
                        poly.userData.frozen = true;
                        poly.setOptions({ clickable: false });
                    }
                });
                this.viewModel.helperLines.forEach(hl => {
                    hl.frozen = true;
                });
            }

            if (tool)
                tool.select(this, oldTool, subTool || null);
        }

        fitBounds(polys: IGoogleMapsPolygon[]) {
            if (polys && polys.length) {
                this.map.fitBounds(this.getBoundsFromPolygons(polys));
                this.selectShapes(polys.map(poly => poly.userData as ShapeData), true);
            }
        }

        fromViewPointToLatLng(p: { x: number, y: number }) {
            var map = this.map,
                scale = this.getPixelFactor(),
                mapBounds = map.getBounds(),
                mapNE = mapBounds.getNorthEast(),
                mapSW = mapBounds.getSouthWest(),
                pNW = new LatLng(mapNE.lat(), mapSW.lng()).ToPoint2D(); // this.fromLatLngToPoint(new google.maps.LatLng(mapNE.lat(), mapSW.lng()));

            return LatLng.FromPoint2D(new Point2D(((pNW.x * scale) + p.x) / scale, ((pNW.y * scale) + p.y) / scale)); // this.fromPointToLatLng(new google.maps.Point(((pNW.x * scale) + p.x) / scale, ((pNW.y * scale) + p.y) / scale), false);
        }

        static getQuadtreeQuadrant(x, y, zoom) {
            var cx = Math.abs(+x);
            var cy = Math.abs(+y);
            var q = [];
            for (var z = zoom; z >= 1; z--) {
                var fx = cx % 2;
                var fy = cy % 2;
                q.unshift(fy * 2 + fx);
                cx = (cx - fx) / 2;
                cy = (cy - fy) / 2;
            }
            return q;
        }

        load(callBack?: () => void) {
            SolarProTool.Ajax("WebServices/MapServices.asmx").Call("GetDataForMapDrawer").Data({isFacade: this.isFacade}).CallBack((result) => {
                this.clear();

                var bounds = new BoundsLatLng();

                if (!result)
                    result = {} as any;

                if (result.Shapes) {
                    // Clear the flag so only real 3D-tile data keeps it.
                    if (result.PlannedWith3DObject === false) {
                        result.Shapes.forEach(shape => shape.LeaveRoofAreaUntouched = false);
                    }
                    let bds = this.importShapes(result.Shapes);
                    if (!bds.IsEmpty)
                        bounds.Expand(bds);
                }

                if (result.ImportedImages) {
                    let bds = this.importImages(result.ImportedImages);
                    if (!bds.IsEmpty && bds.Width < 1000000 && bds.Height < 1000000 && bds.Center.DistanceTo(bounds.Center) < 1000000)
                        bounds.Expand(bds);
                }

                if (this.ghostShapes && this.ghostShapes.length) {
                    this.ghostShapes.forEach(gp => {
                        gp.setMap(null);
                    });
                    this.ghostShapes = null;
                }

                if (result.GhostBorders && result.GhostBorders.length) {
                    var gPaths: google.maps.LatLng[][] = [];

                    result.GhostBorders.forEach(poly => {
                        gPaths.push(poly.points.map(p => new google.maps.LatLng(p.latitude, p.longitude)));
                    });

                    var gPoly = new google.maps.Polygon($.extend({}, {
                        map: this.map,
                        paths: gPaths
                    }, this.ghostShapeStyle) as google.maps.PolygonOptions);

                    this.ghostShapes = [gPoly as any];
                }

                this.autoSelectLayer();

                this.clearSelection();
                if (result.mapTypeId) {
                    if (this.mapTypeIds.some(m => m === result.mapTypeId)) {
                        this.map.setMapTypeId(result.mapTypeId);
                    } else if (result.mapTypeId.indexOf("Google") !== -1) {
                        this.map.setMapTypeId(this.mapTypeIds[1]);
                    }
                }

                if (!bounds.IsEmpty)
                    this.map.fitBounds(bounds.ToGMLatLngBounds());

                // select tool on startup
                var selectedToolName = this.options.isReadOnly ? 'HandTool' : 'DrawTool';
                this.selectTool(selectedToolName);

                if (callBack && typeof callBack === "function")
                    callBack();
            });
        }

        loadImportImages(callBack?: () => void) {
            SolarProTool.Ajax("WebServices/MapServices.asmx").Call("GetImportedImagesForMapDrawer").Data().CallBack((result) => {
                this.viewModel.importedImages.removeAll().forEach(im => {
                    im.setMap(null);
                });

                var bounds = new BoundsLatLng();

                if (!this.viewModel.bounds.IsEmpty)
                    bounds.Expand(this.viewModel.bounds);

                if (result.ImportedImages) {
                    let bds = this.importImages(result.ImportedImages);
                    if (!bds.IsEmpty && bds.Width < 1000000 && bds.Height < 1000000 && bds.Center.DistanceTo(bounds.Center) < 1000000)
                        bounds.Expand(bds);
                }

                if (!bounds.IsEmpty)
                    this.map.fitBounds(bounds.ToGMLatLngBounds());

                this.clearSelection();

                if (callBack && typeof callBack === "function")
                    callBack();
            });
        }

        autoSelectLayer() {
            var viewModel = this.viewModel,
                layers = viewModel.layer.all;

            for (var i = 0, j = layers.length; i < j; i++) {
                var layer = layers[i];
                if (!layer.locked) {
                    viewModel.selectedLayerTypeName = layer.typeName;
                    break;
                }
            }

            if ((viewModel.layer.roof && viewModel.layer.roof.polygons.length) ||
                (viewModel.layer.freeArea && viewModel.layer.freeArea.polygons.length))
                viewModel.detailsViewVisible = true;
        }

        testDepthCanvas() {
            let bd = new MapDrawing.BoundsLatLng();
            let llPolys: MapDrawing.LatLng[][] = [];
            //let gpolys: google.maps.Polygon[] = [];

            this.getAllPolygons().filter(poly => poly.userData && !poly._isDisposed).forEach(poly => {
                var shapeData = poly.userData as ShapeData;
                if (shapeData.typeName === window.RoofTypeName) {
                    llPolys.push(shapeData.latLngs[0]);
                    //let gpoly = new google.maps.Polygon({ paths: poly.getPaths() });
                    //gpolys.push(gpoly);
                    //shapeData.latLngs
                    bd.Expand(shapeData.bounds);
                }
            });

            bd = bd.Extend(5);

            let w = bd.Width,
                h = bd.Height;

            if (w > 0 && w < 1000 && h > 0 && h < 1000) {
                var ocr = this.ocrManager.ocr,
                    zoom: number,
                    pxSize = 256,
                    sizeFactor = Math.min(pxSize / w, pxSize / h),
                    maxSize = Math.max(w, h),
                    width = Math.round(w * sizeFactor),
                    height = Math.round(h * sizeFactor);

                if (maxSize > 500)
                    zoom = 18;
                else if (maxSize > 250)
                    zoom = 19;
                else
                    zoom = 23;

                ocr.request({
                    bounds: bd,
                    level: zoom,
                    renderWidth: width,
                    renderHeight: height,
                    depthMaterial: true,
                    drawFn: (canvas, gl) => {

                        var t0 = performance.now();

                        var depthCanvas = document.createElement("canvas");

                        depthCanvas.width = width;
                        depthCanvas.height = height;

                        depthCanvas.style.position = "absolute";
                        depthCanvas.style.top = "100px";
                        depthCanvas.style.left = "100px";
                        depthCanvas.style.width = width + "px";
                        depthCanvas.style.height = height + "px";
                        depthCanvas.style.zIndex = "1";
                        document.body.appendChild(depthCanvas);

                        var numPixels = width * height,
                            gldata = new Uint8Array(numPixels * 4),
                            x: number,
                            y: number,
                            d: number;

                        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, gldata);

                        var pts: THREE.Vector4[] = [];

                        var plys: number[][][] = [],
                            planes: THREE.Plane[] = [];

                        llPolys.forEach(llPoly => {
                            var positions: number[] = [],
                                minZ = Number.MAX_VALUE;

                            var poly = llPoly.map(ll => {
                                let v = bd.Min.DirectionTo(ll);
                                return [Math.round(v.x * width / w), Math.round(v.y * height / h)];
                            });

                            GMapsUtils.triangulationUtils.pointsInPolygon([poly], (x, y) => {
                                if (x > 0 && x < width && y > 0 && y < height) {
                                    let idx = y * (width * 4) + x * 4,
                                        r = gldata[idx],
                                        g = gldata[idx + 1],
                                        b = gldata[idx + 2],
                                        d = r / 256 + g + b * 256;

                                    positions.push(x / width * w, y / height * h, d);
                                    pts.push(new THREE.Vector4((x / width * w) * 1000, (y / height * h) * 1000, d * 1000, 4));
                                    if (d < minZ)
                                        minZ = d;
                                }
                            });

                            var plane = spt.ThreeJs.utils.approximatePlaneFromPositionArray(positions, minZ);

                            plys.push(poly);
                            planes.push(plane.clone());

                        });

                        var minDepth = Number.MAX_VALUE,
                            maxDepth = 0;

                        //calc min and max depth
                        for (y = 0; y < height; y++) {
                            for (x = 0; x < width; x++) {
                                const gidx = y * (width * 4) + x * 4,
                                    r = gldata[gidx],
                                    g = gldata[gidx + 1],
                                    b = gldata[gidx + 2];

                                d = r / 256 + g + b * 256;

                                if (d < minDepth)
                                    minDepth = d;
                                if (d > maxDepth)
                                    maxDepth = d;
                            }
                        }

                        var ctx = depthCanvas.getContext("2d"),
                            imageData = ctx.createImageData(canvas.width, canvas.height),
                            data = imageData.data,
                            deltaDepth = maxDepth - minDepth;

                        for (y = 0; y < height; y++) {
                            for (x = 0; x < width; x++) {
                                const idx = (height - 1 - y) * (width * 4) + x * 4,
                                    gidx = y * (width * 4) + x * 4,
                                    r = gldata[gidx],
                                    g = gldata[gidx + 1],
                                    b = gldata[gidx + 2];

                                d = r / 256 + g + b * 256;

                                d = Math.min(1, Math.max(0, (d - minDepth) / deltaDepth)) * 255;

                                data[idx] = d;
                                data[idx + 1] = d;
                                data[idx + 2] = d;
                                data[idx + 3] = 255;
                            }
                        }

                        plys.forEach((poly, i) => {
                            var plane = planes[i],
                                r = plane.normal.x * 127.5 + 127.5,
                                g = plane.normal.y * 127.5 + 127.5,
                                b = plane.normal.z * 127.5 + 127.5;

                            console.log(`plane normal x: ${plane.normal.x}, y: ${plane.normal.y}, z: ${plane.normal.z}, angle: ${plane.normal.angleTo(new THREE.Vector3(0, 0, 1)) / Math.PI * 180}`);

                            GMapsUtils.triangulationUtils.pointsInPolygon([poly], (x, y) => {
                                if (x > 0 && x < width && y > 0 && y < height) {
                                    let idx = (height - 1 - Math.round(y)) * (width * 4) + Math.round(x) * 4;
                                    imageData.data[idx] = r;
                                    imageData.data[idx + 1] = g;
                                    imageData.data[idx + 2] = b;
                                }
                            });

                        });

                        console.log(`buidling height: ${deltaDepth} m`);

                        spt.ThreeJs.utils.DebugPolygons(null, null, pts);

                        ctx.putImageData(imageData, 0, 0);

                        var t1 = performance.now();

                        console.log(`Call to plane approximation took ${(t1 - t0) * 0.001} seconds.`);
                    }
                });
            }
        }

        save(callback?: () => void, keepCurrentTool = false) {
            if (LoaderManager.isLoading())
                return false;

            LoaderManager.addLoadingJob();

            // Keep the current tool to avoid restoring stale map data.
            // Used while moving a roof.
            if (!keepCurrentTool) {
                let selectedToolName = this.show3dBuildings ? 'Gis3DBuildingsTool' : this.options.isReadOnly ? 'HandTool' : 'SelectTool';
                this.selectTool(selectedToolName);
            }

            ko.tasks.runEarly();

            setTimeout(this.saveIntern.bind(this, callback), 0);
            LoaderManager.finishLoadingJob();
        }

        getDefaultMapDrawerData(): SolarProTool.MapDrawerData {
            var shapes = this.exportShapes(),
                mapType = "" + this.map.getMapTypeId();

            var roofingID = (($("#Roof_RoofForm_Id:checked").val() == "073ff29a-ca1a-447c-94cb-7fade619355e" || $("#Roof_RoofForm_Id:checked").val() == "78d5978c-58ec-4dee-86b7-4fe2ad9ebf48") ? $("#RoofingElevation").val() : $("#RoofingPitched").val());
            var elevationtype = (($("#Roof_RoofForm_Id:checked").val() == "073ff29a-ca1a-447c-94cb-7fade619355e" || $("#Roof_RoofForm_Id:checked").val() == "78d5978c-58ec-4dee-86b7-4fe2ad9ebf48") ? parseInt($("#ElevationTypeDD").val() as string) : parseInt($("#ElevationTypeDDPitched").val() as string))

            if (isNaN(elevationtype)) {
                elevationtype = 0;
            }

            var data: SolarProTool.MapDrawerData = {
                mapTypeId: mapType,
                Shapes: shapes,
                ImageId: null,
                ImageWidth: 0,
                ImageHeight: 0,
                ImageLatitude: 0,
                ImageLongitude: 0,
                ImageOrientation: 0,
                ImageAlpha: 0,
                MapsImageData: null,
                MapsImageMinLatitude: 0,
                MapsImageMinLongitude: 0,
                MapsImageMaxLatitude: 0,
                MapsImageMaxLongitude: 0,
                ValidationRoofingID: roofingID as string,
                ValidationRoofFormID: $("#Roof_RoofForm_Id:checked").val() as string,
                ValidationElevationType: elevationtype,
                PlannedWith3DObject: !this.viewModel.isDrawingMode
            };
            return data;
        }

         synchSlope(){
            var data: SolarProTool.MapDrawerData = this.getDefaultMapDrawerData();
            let slope: number;

             let shapeData = this.viewModel.layer.building.polygons[0]?.userData as ShapeData;
             if(!shapeData) return;
             
             slope = shapeData.currentSelectedRoofSlope;
            
             if(slope < 0){
                data.Shapes.forEach(shape => {
                    shape.borders.forEach(border => {
                        slope = border.slope;
                    })
                })
             }

             var angleId = '#Roof_Angle';

             if (this.viewModel.isFacade)
                 angleId = '#WallAngle';

             spt.Utils.SetFloatInInput(
                 angleId,
                 Math.round(spt.Utils.GetFloatFromInputValue(slope.toString(), {notImperial: true}) * 100) / 100
             );

            $("#RoofAngleTemp").val($("#RoofModel_Angle").val());

             $(angleId).trigger("change");
            
        }
        
        synchHeight(mapshape? : any){
            
            let shapeData = this.viewModel.layer.building.polygons[0]?.userData as ShapeData;
            if (!shapeData) return;

            var heightId = '#Roof_RoofHeight';
            let height = shapeData.height;

            if (this.viewModel.isFacade) {
                heightId = '#WallHeight';
                if (mapshape)
                    height = mapshape.borders[0].maxy as number;
            }                

            var valueAdjustOpts = this.viewModel.valueAdjustOpts;
 
            spt.Utils.SetFloatInInput(heightId, spt.Utils.GetFloatFromInputValue(
                height.toString(),
                {
                    notImperial: true,
                    from: "mm",
                    to: valueAdjustOpts.to
                }
            ));

            $(heightId).trigger("change");
        }

        synchLength(mapshape){
            let shapeData = this.viewModel.layer.building.polygons[0]?.userData as ShapeData;
            if (!shapeData) return;

            var lengthId = '#WallLength';

            let length = mapshape.borders[0].maxx as number;

            var valueAdjustOpts = this.viewModel.valueAdjustOpts;

            spt.Utils.SetFloatInInput(lengthId, spt.Utils.GetFloatFromInputValue(
                length.toString(),
                {
                    notImperial: true,
                    from: "mm",
                    to: valueAdjustOpts.to
                }
            ));

            $(lengthId).trigger("change");
        }
        
        private saveIntern(callback?: () => void) {
            LoaderManager.addLoadingJob();

            var mapType = "" + this.map.getMapTypeId(),
               isGoogleHD = mapType === "Google HD";

            var data: SolarProTool.MapDrawerData = this.getDefaultMapDrawerData();

            var img = this.viewModel?.currentImportedImage;

            if(this.isFacade){
                this.synchLength(data.Shapes[0]);
                this.synchHeight(data.Shapes[0]);
            }
            
            if (img && img._bounds) {

                var bd = img._bounds;
                var c = bd.Center;

                data.ImageId = img._id;
                data.ImageWidth = bd.Width * 1000;
                data.ImageHeight = bd.Height * 1000;
                data.ImageLatitude = c.Latitude;
                data.ImageLongitude = c.Longitude;
                data.ImageOrientation = img._orientation;
                data.ImageAlpha = img._alpha;
            }

            if (isGoogleHD) {
                let bd = new MapDrawing.BoundsLatLng();

                this.getAllPolygons().filter(poly => poly.userData && !poly._isDisposed).forEach(poly => {
                    var shapeData = poly.userData as ShapeData;
                    bd.Expand(shapeData.bounds);
                });

                let w = bd.Width,
                    h = bd.Height;

                if (w > 0 && w < 1000 && h > 0 && h < 1000) {
                    var ocr = this.ocrManager.ocr,
                        canvas = document.createElement("canvas"),
                        zoom: number,
                        pxSize = 1024,
                        sizeFactor = Math.min(pxSize / w, pxSize / h),
                        maxSize = Math.max(w, h),
                        pxWidth = Math.round(w * sizeFactor),
                        pxHeight = Math.round(h * sizeFactor);

                    if (maxSize > 500)
                        zoom = 18;
                    else if (maxSize > 250)
                        zoom = 19;
                    else
                        zoom = 23;

                    canvas.width = pxWidth;
                    canvas.height = pxHeight;

                    ocr.requestRender(bd, zoom, () => canvas, (success) => {
                        if (success && canvas && typeof canvas.toDataURL == "function") {
                            data.MapsImageData = canvas.toDataURL("image/png");
                            data.MapsImageMinLatitude = bd.Min.Latitude;
                            data.MapsImageMinLongitude = bd.Min.Longitude;
                            data.MapsImageMaxLatitude = bd.Max.Latitude;
                            data.MapsImageMaxLongitude = bd.Max.Longitude;
                        }

                        let validationErrors: string[] = this.validateData(data);
                        if (validationErrors.length > 0) {
                            let errors = validationErrors.join(" ");
                            DManager.showErrorMessage(errors);
                            
                            LoaderManager.finishLoadingJob();
                            return;
                        }

                        this.saveData(data, callback);
                    }, pxWidth, pxHeight);

                    LoaderManager.finishLoadingJob();
                    return;
                }

            }

            let validationErrors: string[] = this.validateData(data);
            if (validationErrors.length > 0) {
                let errors = validationErrors.join(" ");
                DManager.showErrorMessage(errors);

                LoaderManager.finishLoadingJob();
                return;
            }

            this.saveData(data, callback);
            LoaderManager.finishLoadingJob();
        }

        private validateData(data: SolarProTool.MapDrawerData): string[] {
            const dataValidationErrors: string[] = [];

            this.validateRoofsHeight(data, dataValidationErrors);
            this.validateMaxDistance(data, dataValidationErrors);
            this.validateRoofsSouthMarkers(data, dataValidationErrors);
            return dataValidationErrors;
        }

        private validateRoofsSouthMarkers(data: SolarProTool.MapDrawerData, dataValidationErrors: string[]) {
            // Drawing mode validates roofs individually.
            // Missing markers on sibling roofs do not block saving.
            if (this.viewModel?.isDrawingMode)
                return;

            const roofs = data.Shapes.filter(shape => shape.TypeName === window.RoofTypeName);

            if (roofs.length <= 1)
                return;

            const roofsWithoutSouthMarker: string[] = [];

            roofs.forEach(roof => {
                const sm = roof.mapSouthMarker;
                if (!sm || sm.Latitude == null || sm.Longitude == null || sm.Orientation == null || isNaN(sm.Latitude) || isNaN(sm.Longitude) || isNaN(sm.Orientation)) {
                    roofsWithoutSouthMarker.push(roof.Title);
                }
            });

            if (roofsWithoutSouthMarker.length > 0) {
                const invalidRoofsList = roofsWithoutSouthMarker.join(", ");
                let baseMessage: string = $('#validateRoofsSouthMarkersErrorMsg').html();
                dataValidationErrors.push(`${baseMessage} ${invalidRoofsList}`);
            }
        }

        private validateRoofsHeight(data: SolarProTool.MapDrawerData, dataValidationErrors: string[]) {
            const invalidRoofsTitles: Set<string> = new Set();

            let isHeightValid = true;

            data.Shapes.forEach(shape => {
                shape.borders.forEach(border => {
                    border.points.forEach(point => {
                        if (point.z < 0) {
                            isHeightValid = false;
                            invalidRoofsTitles.add(shape.Title);
                        }
                    });
                });
            });

            if (!isHeightValid) {
                const invalidRoofsList = Array.from(invalidRoofsTitles).join(", ");
                let baseMessage: string = $('#validateRoofsHeightErrorMsg').html();
                dataValidationErrors.push(`${baseMessage} ${invalidRoofsList}`);
            }
        }
        
        private validateMaxDistance(data: SolarProTool.MapDrawerData, dataValidationErrors: string[]){
            let invalidRoofsTitles: Set<string> = new Set();
            let isLengthValid = true;

            data.Shapes.forEach(shape => {
                shape.borders.forEach(border => {
                   
                    for(let i = 0; i <= border.points.length-1; i ++){
                        
                        if(border.points[i]?.latitude && border.points[i]?.longitude && border.points[i+1]?.latitude && border.points[i+1]?.longitude){
                            let ltlng1 = new LatLng(border.points[i].latitude, border.points[i].longitude);
                            let ltlng2 = new LatLng(border.points[i+1].latitude, border.points[i+1].longitude);
                            let distance =  ltlng1.DistanceTo(ltlng2);
                            
                            if(distance >= 1000){
                                invalidRoofsTitles.add(shape.Title);
                                isLengthValid = false;
                            }
                        }
                        
                    }
                    
                });
            });
            
            if(!isLengthValid){
                let baseMessage: string = $('#validateRoofsLenghtErrorMsg').html();
                dataValidationErrors.push(`${baseMessage}`);
            }
            
        }

        public async saveData(data: SolarProTool.MapDrawerData, callback?: () => void) {
            const result: SolarProTool.MapDrawerSaveResult = await new Promise(resolve =>
                SolarProTool.Ajax("WebServices/MapServices.asmx")
                    .Call("SaveMapDrawerData")
                    .Data({data: data, building: null})
                    .CallBack(resolve));


            if (!result) {
                if (callback && typeof callback === "function") {
                    callback();
                }
                return;
            }

            if (result.ErrorMessage) {
                DManager.showErrorMessage(result.ErrorMessage, true);
                if (callback && typeof callback === "function") {
                    callback();
                }
                return
            }


            if (this.dialog) {
                DManager.hide(this.dialog);
            }

            const mapDrawerSavedEvt = new CustomEvent("MapDrawerDataSaved", {
                detail: { success: true }
            });

            window.dispatchEvent(mapDrawerSavedEvt);

            if (this.viewModel && $('#Roof_Orientation').length) {
                this.saveMapDrawerDataSetActiveRoofValues(result, this.viewModel.valueAdjustOpts)
            }
            if (callback && typeof callback === "function") {
                callback();
            }
        }
        
        get hasFocus(): boolean {
            return this._hasFocus && (!this.viewModel || !this.viewModel.detailsContentHasFocus);
        }

        set hasFocus(v: boolean) {
            this._hasFocus = v;
        }

        setSeparationLinesFrozen(frozen: boolean) {
            var viewmodel = this.viewModel,
                buildingLayer = viewmodel.layer.building,
                buildingPolys = buildingLayer ? buildingLayer.polygons : null;
            if (buildingPolys != null)
                buildingPolys.forEach(poly => {
                    if (poly.userData && (poly.userData as ShapeData).separationPolylines)
                        (poly.userData as ShapeData).separationPolylines.forEach(sp => { sp.frozen = frozen; });
                });
        }

        getPixelFactor() {
            if (this.map)
                return Math.pow(2, this.map.getZoom());
            return 0;
        }

        setDrawingMode(b: boolean) {
            this.drawingMode = !!b;
        }

        getPolygonsByPoint(viewPosition: google.maps.LatLng) {
            var pointInPolygon = google.maps.geometry.poly.containsLocation;
            return this.getAllPolygons().filter(shape => pointInPolygon(viewPosition, shape as any));
        }

        getAllPolygons(): IGoogleMapsPolygon[] {
            var result: IGoogleMapsPolygon[] = [];
            this.viewModel.layer.all.forEach(layer => {
                layer.polygons.forEach(p => result.push(p));
            });
            return result;
        }

        getByBoundsLatLng(bounds: BoundsLatLng, layers?: PolygonLayer[], noHelperlines?: boolean): ISelectableItem[] {
            var result: ISelectableItem[] = [];
            if (!layers)
                layers = this.viewModel.layer.all;
            for (var i = 0, j = layers.length; i < j; i++) {
                var layer = layers[i];
                if (layer && layer.bounds) {
                    if (!layer.bounds.Overlaps(bounds))
                        continue;
                    var polygons = layer.polygons;
                    for (var k = 0, l = polygons.length; k < l; k++) {
                        var poly = polygons[k],
                            data = poly.userData as ShapeData;
                        if (data && data.bounds) {
                            var b = data.bounds;
                            if (b.Overlaps(bounds))
                                result.push(data);
                        }
                    }
                }

            }
            if (!noHelperlines) {
                var helperLines = this.viewModel.helperLines;
                for (var m = 0, n = helperLines.length; m < n; m++) {
                    result.push(helperLines[m]);
                }
            }

            return result;
        }

        getByLatLng(latLng: LatLng, clickTolerance: number, layers?: PolygonLayer[], noHelperlines?: boolean): ISelectableItem[] {
            var pxFactor = Math.pow(2, this.map.getZoom()),
                offset = clickTolerance / pxFactor,
                p = latLng.ToPoint2D(),
                t = new Point2D(offset, offset),
                bounds = new BoundsLatLng(LatLng.FromPoint2D(p.sub(t)), LatLng.FromPoint2D(p.add(t)));

            return this.getByBoundsLatLng(bounds, layers, noHelperlines);
        }

        getSegmentByPoint(latLng: LatLng, clickTolerance: number, layers?: PolygonLayer[], noHelperlines?: boolean, noGhostShapes?: boolean, segInfo?: { isHelperLine: boolean }): Segment2D {

            var result: Segment2D = null,
                minDist = Number.MAX_VALUE,
                pxFactor = Math.pow(2, this.map.getZoom()),
                p = latLng.ToPoint2D();

            this.getByLatLng(latLng, clickTolerance, layers, noHelperlines).map((item: ISelectableItem) => {
                item.getSegments().forEach(seg => {
                    var dist = seg.distanceToPoint(p) * pxFactor;
                    if (dist <= clickTolerance && dist < minDist) {
                        minDist = dist;
                        result = seg;
                        if (segInfo)
                            segInfo.isHelperLine = item instanceof Helperline;
                    }
                });
            });

            if (!result && !noGhostShapes && this.ghostShapes && this.ghostShapes.length) {
                this.ghostShapes.forEach(sh => {

                    sh.getPaths().getArray().forEach(path => {
                        var points = LatLng.GMLatLngArrayToPoint2D(path.getArray()),
                            len = points.length;

                        for (var i = 0; i < len; i++) {
                            var p1 = points[i],
                                p2 = points[(i + 1) % len],
                                seg = new Segment2D(p1, p2);

                            var dist = seg.distanceToPoint(p) * pxFactor;
                            if (dist <= clickTolerance && dist < minDist) {
                                minDist = dist;
                                result = seg;
                            }
                        }
                    });
                });
            }

            return result;
        }

        getPointByPoint(latLng: LatLng, clickTolerance: number, helperLineIntersections: boolean, snapPolygons: boolean, layers?: PolygonLayer[], noGhostShapes?: boolean, pointInfo?: { isHelperLine: boolean }): Point2D {

            var result: Point2D = null,
                minDist = Number.MAX_VALUE,
                pxFactor = Math.pow(2, this.map.getZoom()),
                p = latLng.ToPoint2D(),
                helperLines = this.viewModel.helperLines;

            if (helperLineIntersections) {
                var hl: Helperline[],
                    len: number;

                if (helperLines.length > 1) {
                    hl = helperLines.filter(helperLine => (helperLine.distanceToPoint(p) * pxFactor) <= clickTolerance);
                    len = hl.length;
                    if (len > 1) {
                        for (let i = 0; i < len; i++) {
                            var hl1 = hl[i];
                            for (var j = i + 1; j < len; j++) {
                                let hl2 = hl[j],
                                    pt = hl1.getIntersection(hl2.Segment);

                                if (pt) {
                                    let dist = pt.DistanceTo(p) * pxFactor;
                                    if (dist <= clickTolerance && dist < minDist) {
                                        minDist = dist;
                                        result = pt;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!result) {
                    var seg = this.getSegmentByPoint(latLng, clickTolerance, layers, true);
                    if (seg) {
                        if (!hl) {
                            hl = helperLines.filter(helperLine => (helperLine.distanceToPoint(p) * pxFactor) <= clickTolerance);
                            len = hl.length;
                        }
                        for (let i = 0; i < len; i++) {
                            let hl1 = hl[i],
                                pt = hl1.getIntersection(seg);
                            if (pt) {
                                let dist = pt.DistanceTo(p) * pxFactor;
                                if (dist <= clickTolerance && dist < minDist) {
                                    minDist = dist;
                                    result = pt;
                                }
                            }
                        }
                    }
                }
                if (result && pointInfo) {
                    pointInfo.isHelperLine = true;
                    // If a polygon vertex exists at the same location, treat it as a vertex snap, not a helper-line snap.
                    if (snapPolygons) {
                        this.getByLatLng(latLng, clickTolerance, layers, true).forEach((item: ISelectableItem) => {
                            item.getPoints().forEach(pts => {
                                pts.forEach(pt => {
                                    if (pt.DistanceTo(p) * pxFactor <= clickTolerance)
                                        pointInfo.isHelperLine = false;
                                });
                            });
                        });
                    }
                }
            }

            if (snapPolygons && !result) {
                var itms = this.getByLatLng(latLng, clickTolerance, layers, true);
                itms.forEach((item: ISelectableItem) => {
                    item.getPoints().forEach((pts) => {
                        pts.forEach(pt => {
                            var dist = pt.DistanceTo(p) * pxFactor;
                            if (dist <= clickTolerance && dist < minDist) {
                                minDist = dist;
                                result = pt;
                            }
                        });
                    });
                });
                if (!result) {
                    itms.forEach((item: ISelectableItem) => {
                        item.getSegments().forEach(seg => {
                            var mpt = seg.getCenter();
                            var dist = mpt.DistanceTo(p) * pxFactor;
                            if (dist <= clickTolerance && dist < minDist) {
                                minDist = dist;
                                result = mpt;
                            }
                        });
                    });
                }
            }

            if (!result && !noGhostShapes && this.ghostShapes && this.ghostShapes.length) {
                this.ghostShapes.forEach(sh => {

                    sh.getPaths().getArray().forEach(path => {
                        var points = LatLng.GMLatLngArrayToPoint2D(path.getArray()),
                            len = points.length;

                        for (var i = 0; i < len; i++) {
                            var pt = points[i],
                                dist = pt.DistanceTo(p) * pxFactor;
                            if (dist <= clickTolerance && dist < minDist) {
                                minDist = dist;
                                result = pt;
                            }
                        }
                    });
                });
            }

            return result;
        }

        closestPointByPoint(latLng: LatLng, clickTolerance: number): Point2D {

            var result: Point2D[] = [],
                pxFactor = Math.pow(2, this.map.getZoom()),
                p = latLng.ToPoint2D(),
                minDist = Number.MAX_VALUE,
                found: Point2D = null;

            this.getByLatLng(latLng, clickTolerance).forEach((item: ISelectableItem) => {
                item.getPoints().forEach((pts) => {
                    pts.forEach(pt => {
                        var dist = pt.DistanceTo(p) * pxFactor;
                        if (dist <= clickTolerance && dist < minDist) {
                            minDist = dist;
                            found = pt;
                        }
                    });
                });
            });

            return found;
        }

        pathToMapPolygon(latLngs: LatLng[], orientationRad: number, origin: LatLng, depth: number, slopeDegree: number, useProjection: boolean, skipCheck?: boolean): SolarProTool.MapPolygon {
            if (!skipCheck && latLngs.length < 3)
                return null;

            var boundsLatLng = BoundsLatLng.FromLatLngs(latLngs);
            if (!skipCheck && boundsLatLng.IsEmpty)
                return null;

            var xAxis = Point2D.FromOrientation(orientationRad);
            var yAxis = xAxis.rot90();
            var slopeFactor = useProjection ? 1 / Math.cos(slopeDegree / 180 * Math.PI) : 1;

            var points = latLngs.map(ll => {
                var p = origin.DirectionTo(ll).mul(1000);
                return new Point2D(xAxis.dot(p), yAxis.dot(p) * slopeFactor);
            });

            var bounds = Bounds2D.FromPoints(points);
            var isClockwise = Point2D.isClockwise(points);

            var resultPoints: SolarProTool.MapCoord[] = latLngs.map((latLng, i) => {
                return {
                    latitude: latLng.Latitude,
                    longitude: latLng.Longitude,
                    altitude: 0,
                    x: points[i].x,
                    y: points[i].y,
                    z: depth
                };
            });

            return {
                points: resultPoints,
                isClockwise: isClockwise,
                minLat: boundsLatLng.Min.Latitude,
                minLng: boundsLatLng.Min.Longitude,
                maxLat: boundsLatLng.Max.Latitude,
                maxLng: boundsLatLng.Max.Longitude,
                minx: Math.round(bounds.Min.x),
                miny: Math.round(bounds.Min.y),
                maxx: Math.round(bounds.Max.x),
                maxy: Math.round(bounds.Max.y),
                slope: slopeDegree,
                useProjection: useProjection,
                width: bounds.Delta.X,
                height: bounds.Delta.Y
            };
        }

        addListener(type: string, listener: (event: IEventManagerEvent) => void): EventManager { return this; }

        hasListener(type: string, listener: (event: IEventManagerEvent) => void): boolean { return false; }

        removeListener(type?: string, listener?: (event: IEventManagerEvent) => void): void { }

        dispatchEvent(event: IEventManagerEvent): void { }

        importImages(importedImages: SolarProTool.ImportedImageFileInfo[]): BoundsLatLng {
            var viewModel = this.viewModel;
            var bounds = new BoundsLatLng();
            importedImages.forEach(importedImage => {
                if (importedImage.Id) {

                    var center = new LatLng(importedImage.Latitude, importedImage.Longitude);

                    let bds = BoundsLatLng.FromCenterWidthHeight(center, importedImage.RealWidth / 1000, importedImage.RealHeight / 1000);
                    if (!bds.IsEmpty)
                        bounds.Expand(bds);

                    LoaderManager.addLoadingJob();
                    spt.Utils.LoadImage(`/handler/ImageHandler.ashx?ID=ImageImportPreview&ImgId=${importedImage.Id}&Guid=${spt.Utils.GenerateGuid()}`,
                        (img) => {

                            viewModel.importedImages.push(new ImageMapOverlay(
                                importedImage.Id,
                                img.src,
                                bds,
                                this.map,
                                img.width,
                                img.height,
                                importedImage.Orientation,
                                importedImage.FileName,
                                importedImage.Alpha));
                            LoaderManager.finishLoadingJob();
                        });
                }
            });
            return bounds;
        }
        saveImportedImage() {

            var img = this.viewModel.currentImportedImage;
            if (!img || !img._bounds) {
                this.selectTool(null);
                return;
            }
            var bd = img._bounds;
            var c = bd.Center;
            var data = {
                id: img._id,
                w: bd.Width * 1000,
                h: bd.Height * 1000,
                latitude: c.Latitude,
                longitude: c.Longitude,
                orientation: img._orientation,
                alpha: img._alpha
            };
            SolarProTool.Ajax("WebServices/MapServices.asmx").Call("EditImportedImage").Data(data).CallBack((result) => {
                this.selectTool(null);
            });
        }
        setMapTypeId(mapType: google.maps.MapTypeId | string) {
            var map = this.map;
            map.setMapTypeId(mapType);
        }
        createOverlayText(layer?: PolygonLayer, nextPoint?: LatLng) {
            if (!layer)
                layer = this.viewModel.currentLayer;

            var size = 16,
                margin = 6;

            return new OverlayText().set({
                nextPoint: nextPoint,
                size: size,
                fontStyle: "bold",
                fillPadding: 1,
                margin: margin,
                visible: false,
                textStyle: layer.shapeSelectedStyle.strokeColor,
                fillStyle: new Color().setStyle(layer.shapeStyle.fillColor).premultiplyAlpha(layer.shapeStyle.fillOpacity).toStringRgba(0.7)
            }).setCanvasOverlay(this.canvasOverlay);
        }
        setMeasureText(ot: OverlayText, ll1: LatLng, ll2: LatLng) {
            var valueAdjustOpts = this.viewModel.valueAdjustOpts;
            var imperial = window.UseImperialSystem;
            var inputLength = this.viewModel.cmdEdgeLength / 1000;
            var distance = ll1.DistanceTo(ll2);
            var newLength;
            if (inputLength != 0 && distance > inputLength) {
                newLength = inputLength;
            }
            else if (distance < inputLength) {
                newLength = distance;
            }
            else {
                newLength = distance;
            }
            // BUG Meter or mm parameter changes both the existing roof and the fixed side measurements makeing one inacurate and the other one gets two addition zeros.
            ot.set({
                text: spt.Utils.GetFloatFromInputValue("" + newLength,
                    {
                        precision: valueAdjustOpts.precision,
                        isFeet: imperial,
                        notImperial: !imperial,
                        from: "m",
                        to: valueAdjustOpts.to
                    }) + " " + valueAdjustOpts.to,
                latLng: ll1.add(ll2).mul(0.5),
                visible: true,
                angle: ll1.AngleTo(ll2),
                maxWidth: ll1.ToPoint2D().DistanceTo(ll2.ToPoint2D()) * 0.8
            });
        }
		
        setAngleText(ot: OverlayText, left: LatLng, corner: LatLng, right: LatLng) {
            var l = left.ToPoint2D();
            var c = corner.ToPoint2D();
            var r = right.ToPoint2D();

            var tl = l.sub(c);
            var tr = r.sub(c);

            var lenl = tl.GetLength();
            var lenr = tr.GetLength();

            var nl = tl.divide(lenl);
            var nr = tr.divide(lenr);

            var ang = Math.acos(nl.dot(nr)) / Math.PI * 180;
            var angTxt = (Math.round(ang * 10) / 10) + " °";

            if ((<any>$).global.culture)
                angTxt.replace(".", (<any>$).global.culture.numberFormat["."]);

            var nc = nl.add(nr).GetNormalized();

            var tc = nc.rotr90();

            ot.set({
                text: angTxt,
                latLng: corner,
                visible: true,
                angle: Math.atan2(tc.y, tc.x),
                maxWidth: Math.min(lenl, lenr),
                alignUpper: Point2D.YAxis.dot(nc) > 0
            });
        }

        setCoordsText(ot: OverlayText, corner: LatLng) {
            var valueAdjustOpts = this.viewModel.valueAdjustOpts;
            var imperial = window.UseImperialSystem;

            var cord = this.viewModel.referenceLatLng.DirectionTo(corner);

            var xVal = Math.round(spt.Utils.GetFloatFromInputValue("" + cord.x,
                {
                    precision: valueAdjustOpts.precision,
                    isFeet: imperial,
                    notImperial: !imperial,
                    from: "m",
                    to: valueAdjustOpts.to
                }));

            var yVal = Math.round(spt.Utils.GetFloatFromInputValue("" + cord.y,
                {
                    precision: valueAdjustOpts.precision,
                    isFeet: imperial,
                    notImperial: !imperial,
                    from: "m",
                    to: valueAdjustOpts.to
                }));

            var coordsTxt = `(${xVal},${yVal})`;

            ot.set({
                text: coordsTxt,
                latLng: corner,
                visible: true,
                angle: 0,
                alignUpper: true
            });

        }

        setCoordNumberText(ot: OverlayText, corner: LatLng, num: number, hidden?: boolean) {
            ot.set({
                text: 'P' + (num > 99 ? ('' + num) : ('0' + num).slice(-2)),
                latLng: corner,
                visible: !hidden,
                angle: 0,
                alignUpper: true
            });
        }

        keyDownHandler: (e: KeyboardEvent) => void;
        keyUpHandler: (e: KeyboardEvent) => void;
        mouseDownHandler: (e: MouseEvent) => void;
        mouseUpHandler: (e: MouseEvent) => void;
        mouseMoveHandler: (e: MouseEvent) => void;
        viewMouseDownHandler: (e: MouseEvent) => void;
        onDialogClose() {
            this.viewModel.currentTool.deselect(this);
            this.clear();
            this.unBindEvents();
            this.getAllPolygons().forEach(poly => {
                poly.setMap(null);
            });

            if (this.tileManager) {
                this.tileManager.forEach(tm => {
                    if (tm)
                        tm.abortAll();
                });
            }
            SetPaddingBack();
        }

        /**
         * Update the input-fields on the page.
         * Extracted from `saveMapDrawerData()`
         *
         * @param result response of the Webservice
         * @param valueAdjustOpts `PolyDesigner.ViewModel.valueAdjustOpts`
         * @see PolyDesigner.ViewModel.valueAdjustOpts
         * @private
         */
        private saveMapDrawerDataSetActiveRoofValues(result: SolarProTool.MapDrawerSaveResult, valueAdjustOpts: spt.Utils.IFloatFromInputOptions){
            
            spt.Utils.SetFloatInInput('#Roof_Orientation', spt.Utils.GetFloatFromInputValue(result.RoofOrientation.toString(), {notImperial: true}));

            spt.Utils.SetFloatInInput('#Roof_RoofHeight', spt.Utils.GetFloatFromInputValue(
                result.RoofHeight.toString(),
                {
                    notImperial: true,
                    from: "mm",
                    to: valueAdjustOpts.to
                }
            ));
            
            if (this.isFacade){
                spt.Utils.SetFloatInInput(
                    '#WallAngle',
                    Math.round(spt.Utils.GetFloatFromInputValue(result.RoofAngle.toString(), {notImperial: true}) * 100) / 100
                ); 
            }else {
                spt.Utils.SetFloatInInput(
                    '#Roof_Angle',
                    Math.round(spt.Utils.GetFloatFromInputValue(result.RoofAngle.toString(), {notImperial: true}) * 100) / 100
                );
            }
            

            $("#RoofAngleTemp").val($("#Roof_Angle").val());

            if (result.RoofName) {
                if ($('#Roof_Title').length)
                    $('#Roof_Title').val(result.RoofName);
                if ($('.prInfoRoofTitle').length)
                    $('.prInfoRoofTitle').text(result.RoofName);
            }

            if (result.IsMultiRoofBuilding !== undefined)
                window.isMultiRoofBuilding = !!result.IsMultiRoofBuilding;

            if (result.ProcessStep >= 5) {
                window.ConfirmDialogSaveOnlyClick = function () {
                    DManager.hide('confirmation_dialog_saveOrReCreate');
                };

                window.ConfirmDialogSaveAndReCreateClick = function () {
                    AManager.AjaxWithLoading('AnordnungsService.asmx', 'GenerateAll', {multiRoof: window.isMultiRoofBuilding}, window.ConfirmDialogSaveOnlyClick);
                };

                DManager.show('confirmation_dialog_saveOrReCreate');
            }
        }
        
        /**
         * Creates the custom styled Control Group for switching the maps (google, bing, canvas, etc.)
         * @param currentActiveMapTypeId Current active map type id (on initialization)
         * @param map Current active map
         */
        private getMapDrawerControlBtnGroup(currentActiveMapTypeId:string, map: google.maps.Map): HTMLDivElement {
            // create the Bootstrap button group element
            const btnGroup = document.createElement<any>("div");
            btnGroup.role = "group";
            btnGroup.classList.add("btn-group", "btn-group-lg", "map-drawer-maptype-control-group");

            // adds the individual map types from via id
            this.mapTypeIds.forEach(mapTypeId=> {
                const btn = this.getMapDrawerControlBtn(mapTypeId);

                if (mapTypeId == currentActiveMapTypeId) {
                    btn.classList.add("active");
                }

                btnGroup.appendChild(btn);
                if (!this.isFacade) {
                    btnGroup.appendChild(this.getMapDrawerControlSpacer());
                }
            });

            map.addListener("maptypeid_changed", () => {
                btnGroup.querySelectorAll("button.map-drawer-maptype-control-btn").forEach(btn => {
                    // remove the existing active from the buttons
                    btn.classList.remove("active");

                    // add active class to current button
                    if (this.getMapTypeButtonId(map.getMapTypeId() as string) === btn.id) {
                        btn.classList.add("active");
                    }
                });
            })

            return btnGroup;
        }

        /**
         * Creates a small vertical spacer for the map drawer control buttons
         */
        private getMapDrawerControlSpacer() {
            const verticalDivider = document.createElement("div");
            const spacer = document.createElement("div");

            // background withe + display flex for algin self
            spacer.classList.add("bg-white", "d-flex");

            verticalDivider.style.backgroundColor = "#E0DFE1";
            verticalDivider.style.width = "3px";
            verticalDivider.style.height = "75%";
            verticalDivider.style.alignSelf = "center";
            verticalDivider.style.padding = "0";

            spacer.appendChild(verticalDivider)
            return spacer;
        }

        private getMapDrawerControlBtn(mapTypeId: string) : HTMLButtonElement {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.id = this.getMapTypeButtonId(mapTypeId);
            btn.classList.add("btn", "bg-white", "map-drawer-maptype-control-btn");
            btn.textContent = mapTypeId;

            btn.addEventListener("click", evt => {
                // update the map to given map type
                this.map.setMapTypeId(mapTypeId);
            })

            return btn;
        }

        getMapTypeButtonId(mapTypeId: string): string {
            return `maptype-button-${mapTypeId.replace(" ", "")}`;
        }

        /**
         * Dev-only map background switch. Enabled with the "?mapbg=canvas" url parameter (e.g. ?mapbg=canvas),
         */
        private getDevMapBackgroundConfig(): { enabled: boolean; initialMapTypeId: string | null } {
            try {
                const storageKey = "mapbg";
                const params = new URLSearchParams(window.location.search);
                let value: string | null;

                if (params.has(storageKey)) {
                    value = (params.get(storageKey) || "").toLowerCase();
                    if (value === "off" || value === "false" || value === "none") {
                        window.localStorage.removeItem(storageKey);
                        return { enabled: false, initialMapTypeId: null };
                    }
                    window.localStorage.setItem(storageKey, value);
                } else {
                    value = window.localStorage.getItem(storageKey);
                }

                if (value === null) {
                    return { enabled: false, initialMapTypeId: null };
                }

                const initialMapTypeId =
                    value === "canvas" ? MapDrawer.EmptyCanvas :
                    value === "google" || value === "satellite" ? "Google" :
                    null;
                return { enabled: true, initialMapTypeId };
            } catch {
                return { enabled: false, initialMapTypeId: null };
            }
        }

        private SHOW_3D_BUILDINGS_BUTTON_TEXT = {
            SHOW: translationForType("Use3DAutoMode"),
            HIDE: translationForType("UseDrawMode")
        };

        private getShow3DBuildingBtn() {

            const btn = document.createElement("button");
            this.show3dBuildingsBtn = btn;
            btn.type = "button";
            btn.id = "show3dBuildings";
            btn.classList.add("btn", "btn-outline-secondary", "clickable-map-bg");
            btn.style.marginTop = "10px";
            btn.textContent = this.SHOW_3D_BUILDINGS_BUTTON_TEXT.SHOW;

            btn.addEventListener("click", () => {
                this.show3dBuildings = !this.show3dBuildings;
                if (this.show3dBuildings) {
                    (window as any).lsApp?.storeRemoveItem?.('Editor3DData');
                    (window as any).lsApp?.storeRemoveItem?.('MapDrawerData');
                }
                this.viewModel.toggleGis3DBuildingsTool(this.show3dBuildings);
                this.updateShow3DBuildingsButtonState();
                
            });
            
            return btn;
        }

        private getGoToProjectBtn() {
            const btn = document.createElement("button");
            this.goToProjectBtn = btn;
            btn.type = "button";
            btn.classList.add("btn", "btn-customer", "map-drawer-go-to-project-btn");
            btn.style.marginTop = "10px";
            btn.style.marginLeft = "5px";
            btn.title = translationForType("GoToProjectLocation");
            btn.innerHTML = '<i class="fa-solid fa-crosshairs"></i>';
            btn.hidden = true;
            btn.addEventListener("click", () => this.viewModel.moveToProjectAddress());
            return btn;
        }

        use3DMode() {
            this.show3dBuildings = true;
            this.viewModel.toggleGis3DBuildingsTool(this.show3dBuildings);
            this.updateShow3DBuildingsButtonState();
        }
        
        useDrawingMode(){
            this.show3dBuildings = false;
            const gis3dTool = this.viewModel.toolIcons?.["Gis3DBuildingsTool"] as Gis3DBuildingsTool | undefined;
            gis3dTool?.keepInfoBoxOnNextDeselect();
            this.viewModel.toggleGis3DBuildingsTool(this.show3dBuildings);
            this.updateShow3DBuildingsButtonState();
            this.showManualRoofInfoBox();
        }

        private showManualRoofInfoBox() {
            (window as any).lsJsInvokable?.reportStepperEditorEvent?.({
                name: 'manual-roof-step-changed',
                value: 1,
                source: 'roof'
            });
        }

        private get90DegreeBtn() {

            const btn = document.createElement("button");
            
            this.showNinetyDegreeCorrectionBtn = btn;
            
            let activeBtn = this.ninetyDegreeCorrection ? "active" : "";
            
            btn.type = "button";
            btn.id = "90DegreeCorrection";
            btn.classList.add("btn", activeBtn, "bg-white", "map-drawer-maptype-control-btn");
            btn.textContent = translationForType("Correction90Degree"); 
            btn.setAttribute('data-bs-toggle', 'tooltip');
            btn.setAttribute('data-bs-placement', 'bottom');
            btn.title = translationForType("Correction90DegreeText");
            


            btn.addEventListener("click", () => {
                this.ninetyDegreeCorrection = !this.ninetyDegreeCorrection;
                // this.viewModel.toggleGis3DBuildingsTool(this.show3dBuildings);
                this.updateShow90DegreeState();
            });

            return btn;
        }
        
        private updateShow90DegreeState() {
            const isActive = this.ninetyDegreeCorrection;
            
            if (isActive) {
                this.showNinetyDegreeCorrectionBtn.classList.add("active");
            } else {
                this.showNinetyDegreeCorrectionBtn.classList.remove("active");
            }
        }

        private updateShow3DBuildingsButtonState() {
            if (!this.show3dBuildingsBtn) {
                return;
            }

            const TEXT = this.SHOW_3D_BUILDINGS_BUTTON_TEXT;
            this.show3dBuildingsBtn.textContent = this.show3dBuildings ? TEXT.HIDE : TEXT.SHOW;
        }

        regenerateReferencePoly() : ShapeData {
            var referenceLayer = this.viewModel.layer.referenceLayer,
                referencePoly = referenceLayer.polygons.length ? referenceLayer.polygons[0] : null;

            if (!referencePoly || referencePoly._isDisposed || !referencePoly.userData)
                return null;

            let referenceData = referencePoly.userData as ShapeData;

            referenceData.regenerate();

            return referenceData;
        }
    }

    function translationForType(typeName: string) {
        // translation for display type
        let displayTypeTrans = typeName;
        if (typeName === "Use3DAutoMode")
            displayTypeTrans = window.translations["Use3DAutoMode"];
        else if (typeName === "UseDrawMode")
            displayTypeTrans = window.translations["UseDrawMode"];
        else if (typeName === "Correction90Degree")
            displayTypeTrans = window.translations["Correction90Degree"];
        else if (typeName === "Correction90DegreeText")
            displayTypeTrans = window.translations["Correction90DegreeText"];
        else if(typeName === "GoToProjectLocation"){
            displayTypeTrans = window.translations["Menu3D_GoToTitle"];
        }

        return displayTypeTrans;
    }

    EventManager.apply(MapDrawer.prototype);
}
